export const kn = {
	content: `
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:dt="uuid:C2F41010-65B3-11d1-A29F-00AA00C14882" xmlns="http://www.w3.org/TR/REC-html40">
    <head>
        <meta http-equiv=Content-Type content="text/html; charset=utf-8">
        <meta name=ProgId content=Word.Document>
        <meta name=Generator content="Microsoft Word 14">
        <meta name=Originator content="Microsoft Word 14">
        <link rel=File-List href="Finvu (CTPL)_Terms and Conditions_KN.files/filelist.xml">
        <title>Finvu</title>
        <!--[if gte mso 9]><xml><o:DocumentProperties><o:Author>Mr. Jaipreet Singh Chhatwal</o:Author><o:LastAuthor>Mukthyar Lukmandin</o:LastAuthor><o:Revision>1</o:Revision><o:Pages>4</o:Pages><o:Characters>22979</o:Characters><o:Lines>191</o:Lines><o:Paragraphs>53</o:Paragraphs></o:DocumentProperties><o:CustomDocumentProperties><o:GrammarlyDocumentId dt:dt="string" >68ffa36e7d9bbf332e92e069fa30ea69ccd30aff8bdce869d49b9b87b83fa573</o:GrammarlyDocumentId><o:KSOProductBuildVer dt:dt="string" >1033-12.2.0.20795</o:KSOProductBuildVer><o:ICV dt:dt="string" >E09E2CF19D5440689926A2E61E4D98E7_13</o:ICV></o:CustomDocumentProperties></xml><![endif]-->
        <!--[if gte mso 9]><xml><o:OfficeDocumentSettings></o:OfficeDocumentSettings></xml><![endif]-->
        <!--[if gte mso 9]><xml><w:WordDocument><w:BrowserLevel>MicrosoftInternetExplorer4</w:BrowserLevel><w:DisplayHorizontalDrawingGridEvery>0</w:DisplayHorizontalDrawingGridEvery><w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery><w:DocumentKind>DocumentNotSpecified</w:DocumentKind><w:DrawingGridVerticalSpacing>7.8 磅</w:DrawingGridVerticalSpacing><w:PunctuationKerning></w:PunctuationKerning><w:View>Web</w:View><w:Compatibility><w:DontGrowAutofit/><w:DoNotExpandShiftReturn/></w:Compatibility><w:Zoom>0</w:Zoom></w:WordDocument></xml><![endif]-->
        <!--[if gte mso 9]><xml><w:LatentStyles DefLockedState="false"  DefUnhideWhenUsed="true"  DefSemiHidden="true"  DefQFormat="false"  DefPriority="99"  LatentStyleCount="260" >
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Normal" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="heading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footer" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="35"  SemiHidden="false"  QFormat="true"  Name="caption" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of figures" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope return" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="line number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="page number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of authorities" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="macro" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="toa heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="10"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Title" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Closing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="1"  SemiHidden="false"  Name="Default Paragraph Font" ></w:LsdException>
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Body Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Message Header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="11"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Subtitle" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Salutation" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Date" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Note Heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Block Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Hyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="FollowedHyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="22"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Strong" ></w:LsdException>
<w:LsdException Locked="false"  Priority="20"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Emphasis" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Document Map" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Plain Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="E-mail Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal (Web)" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Acronym" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Cite" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Code" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Definition" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Keyboard" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Preformatted" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Sample" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Typewriter" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Variable" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Table" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation subject" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / a / i" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / 1.1 / 1.1.1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Article / Section" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Contemporary" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Elegant" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Professional" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Balloon Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Table Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Theme" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Placeholder Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No Spacing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Paragraph" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Intense Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 6" ></w:LsdException>
</w:LatentStyles></xml><![endif]-->
        <style>
            @font-face {
                font-family: "Times New Roman";
            }

            @font-face {
                font-family: "宋体";
            }

            @font-face {
                font-family: "Courier New";
            }

            @font-face {
                font-family: "Wingdings";
            }

            @font-face {
                font-family: "Anek Kannada";
            }

            @font-face {
                font-family: "Arial";
            }

            @list l0:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l0:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l0:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l1:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l1:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l2:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l2:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l3:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l3:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l4:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l4:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l5:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l5:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l6:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l6:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level1 {
                mso-level-start-at: 3;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Times New Roman';
            }

            @list l7:level2 {
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "%1.%2";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(22,28,45);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l7:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l7:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l8:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l8:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l9:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l9:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l10:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l10:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l11:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l11:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level1 {
                mso-level-start-at: 4;
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l12:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l12:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l13:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l13:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l14:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l14:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l15:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l15:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l16:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l16:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l17:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l17:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l18:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l18:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level1 {
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
                mso-level-text: "%1.";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(22,28,45);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l19:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l19:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l20:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l20:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l21:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l21:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level1 {
                mso-level-number-format: lower-roman;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l22:level2 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l22:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level1 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "(%1)";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Anek Kannada';
                mso-fareast-font-family: Arial;
                color: rgb(56,76,116);
                letter-spacing: 0.0000pt;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            @list l23:level2 {
                mso-level-number-format: alpha-lower;
                mso-level-suffix: tab;
                mso-level-text: "%1.%2";
                mso-level-tab-stop: none;
                mso-level-number-position: left;
                margin-left: 0.0000pt;
                text-indent: 0.0000pt;
                font-family: 'Times New Roman';
            }

            @list l23:level3 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level4 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level5 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level6 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level7 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level8 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            @list l23:level9 {
                mso-level-start-at: 0;
                mso-level-number-format: decimal;
                mso-level-suffix: tab;
            }

            p.MsoNormal {
                mso-style-name: Normal;
                mso-style-parent: "";
                margin: 0pt;
                margin-bottom: .0001pt;
                mso-pagination: none;
                font-family: 'Courier New';
                color: rgb(0,0,0);
                font-size: 12.0000pt;
            }

            span.10 {
                font-family: 'Courier New';
            }

            span.15 {
                font-family: Arial;
                color: rgb(56,76,116);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            span.16 {
                font-family: 'Times New Roman';
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 10.0000pt;
            }

            span.17 {
                font-family: Arial;
                color: rgb(22,28,45);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 7.5000pt;
            }

            span.18 {
                font-family: Arial;
                color: rgb(56,76,116);
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                font-size: 12.75pt;
            }

            p.19 {
                mso-style-name: "Header or footer \(2\)";
                margin: 0pt;
                margin-bottom: .0001pt;
                mso-pagination: none;
                font-family: 'Times New Roman';
                color: rgb(0,0,0);
                font-size: 10.0000pt;
            }

            p.20 {
                mso-style-name: Other;
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                line-height: 150%;
                font-family: Arial;
                color: rgb(56,76,116);
                font-size: 12.75pt;
            }

            p.21 {
                mso-style-name: "Heading \#1";
                margin-top: 29.0000pt;
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                mso-outline-level: 1;
                font-family: Arial;
                color: rgb(22,28,45);
                font-size: 7.5000pt;
            }

            p.MsoBodyText {
                mso-style-name: "Body Text";
                margin-bottom: 4.0000pt;
                mso-pagination: none;
                line-height: 150%;
                font-family: Arial;
                color: rgb(56,76,116);
                font-size: 12.75pt;
            }

            span.msoIns {
                mso-style-type: export-only;
                mso-style-name: "";
                text-decoration: underline;
                text-underline: single;
                color: blue;
            }

            span.msoDel {
                mso-style-type: export-only;
                mso-style-name: "";
                text-decoration: line-through;
                color: red;
            }

            table.MsoNormalTable {
                mso-style-name: "Table Normal";
                mso-style-parent: "";
                mso-style-noshow: yes;
                mso-tstyle-rowband-size: 0;
                mso-tstyle-colband-size: 0;
                mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
                mso-para-margin: 0pt;
                mso-para-margin-bottom: .0001pt;
                mso-pagination: widow-orphan;
                font-family: 'Times New Roman';
                font-size: 10.0000pt;
                mso-ansi-language: #0400;
                mso-fareast-language: #0400;
                mso-bidi-language: #0400;
            }

            @page {
                mso-page-border-surround-header: no;
                mso-page-border-surround-footer: no;
            }

            @page Section0 {
                margin-top: 27.0000pt;
                margin-bottom: 27.0000pt;
                margin-left: 67.7000pt;
                margin-right: 22.1000pt;
                size: 612.0000pt 792.0000pt;
                layout-grid: 18.0000pt;
                mso-header-margin: 0.0000pt;
                mso-footer-margin: 0.1500pt;
                mso-footer: url("Finvu%20\(CTPL\)_Terms%20and%20Conditions_KN.files/header.html") f0;
            }

            div.Section0 {
                page: Section0;
            }
        </style>
    </head>
    <body style="tab-interval:36pt;text-justify-trim:punctuation;">
        <!--StartFragment-->
        <div class="Section0" style="layout-grid:18.0000pt;">
            <p class=21 align=justify style="margin-top:12.0000pt;margin-right:20.9000pt;page-break-after:avoid;
mso-pagination:lines-together;text-align:justify;text-justify:inter-ideograph;">
                <a name="bookmark0"></a>
                <span class="17" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:22.5000pt;">ಸೇವಾ ನಿಯಮಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-size:22.5000pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:12.0000pt;text-align:justify;
text-justify:inter-ideograph;">
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಜನವರಿ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">2, 2025 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರಂದು ನವೀಕರಿಸಲಾಗಿದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(80,102,144);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;border-bottom:1.0000pt solid rgb(173,173,173);
mso-border-bottom-alt:0.5000pt solid rgb(173,173,173);padding:0pt 0pt 1pt 0pt ;text-align:justify;
text-justify:inter-ideograph;">
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಯಮಗಳು</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") Finvu </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಪ್ಲಿಕೇಶನ್ ಮತ್ತು ವೆಬ್ಸೈಟ್ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">("</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್ಫಾರ್ಮ್</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">") </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮತ್ತು ಸೇವೆಗಳ ಪ್ರವೇಶ ಮತ್ತು ಬಳಕೆಯನ್ನು ನಿಯಂತ್ರಿಸುತ್ತವೆ </span>
                <i style="mso-bidi-font-style:normal">
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;mso-ansi-font-style:italic;
mso-bidi-font-style:normal;font-variant:normal;font-size:12.75pt;">(</span>
                </i>
                <i>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:italic;
font-variant:normal;font-size:12.75pt;">ಕೆಳಗೆ ವ್ಯಾಖ್ಯಾನಿಸಲಾಗಿದೆ</span>
                </i>
                <i style="mso-bidi-font-style:normal">
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;mso-ansi-font-style:italic;
mso-bidi-font-style:normal;font-variant:normal;font-size:12.75pt;">).</span>
                </i>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span>
                    <a href="http://www.finvu.in/privacy">
                        <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">www.finvu.in/privacy</span>
                    </a>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ಲಭ್ಯವಿರುವ ನಮ್ಮ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(“</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗೌಪ್ಯತಾ ನೀತಿ</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">”) &nbsp;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮತ್ತು ಕಾಲಕಾಲಕ್ಕೆ ನಮ್ಮಿಂದ ಲಭ್ಯವಾಗುವಂತೆ ಅಥವಾ ಹೊರಡಿಸಲಾದ ಯಾವುದೇ ಮಾರ್ಗಸೂಚಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹೆಚ್ಚುವರಿ ನಿಯಮಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀತಿಗಳು ಅಥವಾ ಹಕ್ಕು ನಿರಾಕರಣೆಗಳನ್ನು ಸಹ ಒಳಗೊಂಡಿವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳನ್ನು ಇಲ್ಲಿ ನೀಡಿರುವ ನಿಬಂಧನೆಗಳಿಗೆ ಅನುಗುಣವಾಗಿ ನಾವು ತಿದ್ದುಪಡಿ ಮಾಡಬಹುದು ಮತ್ತು ಕಾಲಕಾಲಕ್ಕೆ ತಿದ್ದುಪಡಿ ಮಾಡಲಾದ ನಿಯಮಗಳು ನಿಮಗೆ ಅನ್ವಯಿಸುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಯಾವಾಗಲೂ ಪ್ಲಾಟ್ಫಾರ್ಮ್ ನಲ್ಲಿ ಈ ನಿಯಮಗಳ ಪ್ರಸ್ತುತ ಆವೃತ್ತಿಯನ್ನು ಪರಿಶೀಲಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Cookiejar Technologies Private Limited (</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಂಪನಿ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">", "</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾವು</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">", "Finvu"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ </span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮಗೆ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳ ಯಾವುದೇ ಬಳಕೆದಾರರು ಮತ್ತು ನಮ್ಮ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪರಿಸರವನ್ನು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ </span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬಳಸುವ ಯಾವುದೇ ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರ ಅಥವಾ ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರರ ನಡುವೆ ಬಂಧಿಸುವ ಮತ್ತು ಜಾರಿಗೊಳಿಸಬಹುದಾದ ಕಾನೂನು ಒಪ್ಪಂದವನ್ನು ರೂಪಿಸುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. Cookiejar Technologies Private Limited, RBI </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಂದ ಪರವಾನಗಿ ಪಡೆದಿದೆ ಮತ್ತು ಖಾತೆ ಸಂಗ್ರಾಹಕರಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸಲು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India (RBI) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀಡಿದ ನೋಂದಣಿ ಪ್ರಮಾಣಪತ್ರವನ್ನು ಹೊಂದಿದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಂಪನಿಯು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಾಯ್ದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 1934 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರ ಸೆಕ್ಷನ್ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">45 IA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಡಿಯಲ್ಲಿ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀಡಿದ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">06 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾರ್ಚ್ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">2020 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದಿನಾಂಕದ ಮಾನ್ಯ ನೋಂದಣಿ ಪ್ರಮಾಣಪತ್ರವನ್ನು ಹೊಂದಿದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(a) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳಲು ಮತ್ತು ಅವುಗಳಿಗೆ ಬದ್ಧರಾಗಲು ಸಂಪೂರ್ಣ ಕಾನೂನು ಸಾಮರ್ಥ್ಯ ಮತ್ತು ಅಧಿಕಾರವನ್ನು ಹೊಂದಿದ್ದೀರಿ ಎಂದು ನೀವು ಪ್ರತಿನಿಧಿಸುತ್ತೀರಿ ಮತ್ತು ಖಾತರಿಪಡಿಸುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, (b) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಒಬ್ಬ ವ್ಯಕ್ತಿಯಾಗಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಹದಿನೆಂಟು ವರ್ಷ ಅಥವಾ ಅದಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ವಯಸ್ಸಿನವರಾಗಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">18 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವರ್ಷಕ್ಕಿಂತ ಕಡಿಮೆ ವಯಸ್ಸಿನವರಾಗಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳನ್ನು ಬಳಸಲು ನೀವು ಪೋಷಕರು ಅಥವಾ ಕಾನೂನುಬದ್ಧ ಪೋಷಕರ ಸಹಾಯವನ್ನು ಪಡೆಯಬೇಕು ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(c) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಭಾರತೀಯ ನಿವಾಸಿಯಾಗಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಒಂದು ಘಟಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂಸ್ಥೆ ಅಥವಾ ಯಾವುದೇ ಇತರ ಕಾನೂನುಬದ್ಧ ವ್ಯಕ್ತಿಯನ್ನು ಪ್ರತಿನಿಧಿಸಿದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂತಹ ಘಟಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂಸ್ಥೆ ಅಥವಾ ಕಾನೂನುಬದ್ಧ ವ್ಯಕ್ತಿಯನ್ನು ಈ ನಿಯಮಗಳಿಗೆ ಬಂಧಿಸುವ ಅಗತ್ಯ ಅಧಿಕಾರ ಮತ್ತು ಅಧಿಕಾರವನ್ನು ನೀವು ಹೊಂದಿದ್ದೀರಿ ಎಂದು ನೀವು ದೃಢೀಕರಿಸುತ್ತೀರಿ ಮತ್ತು ಪ್ರತಿನಿಧಿಸುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;
line-height:144%;">
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಪ್ಲಾಟ್ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬಳಸುವ ಮೂಲಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಈ ನಿಯಮಗಳನ್ನು ಓದಿದ್ದೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೀರಿ ಮತ್ತು ಅವುಗಳಿಗೆ ಬದ್ಧರಾಗಿದ್ದೀರಿ ಮತ್ತು ಇಲ್ಲಿ ಪಟ್ಟಿ ಮಾಡಲಾದ ಅವಶ್ಯಕತೆಗಳನ್ನು ಅನುಸರಿಸುತ್ತೀರಿ ಎಂದು ನೀವು ಒಪ್ಪುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಈ ಎಲ್ಲಾ ನಿಯಮಗಳಿಗೆ ಒಪ್ಪದಿದ್ದರೆ ಅಥವಾ ಇಲ್ಲಿ ಪಟ್ಟಿ ಮಾಡಲಾದ ಅವಶ್ಯಕತೆಗಳನ್ನು ಅನುಸರಿಸದಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದಯವಿಟ್ಟು ಪ್ಲಾಟ್ಫಾರ್ಮ್ ಅನ್ನು ಪ್ರವೇಶಿಸಬೇಡಿ ಅಥವಾ ಸೇವೆಗಳು ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ನು ಬಳಸಬೇಡಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.1000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        1.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವ್ಯಾಖ್ಯಾನಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:157%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <u>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">https://www.rbi.or</span>
                </u>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">g</span>
                <u>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">.in/Scripts/BS_ViewMasDirections.asDx?id=</span>
                </u>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">10598 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಲಭ್ಯವಿರುವಂತೆ ಕಾಲಕಾಲಕ್ಕೆ ತಿದ್ದುಪಡಿ ಮಾಡಲಾದ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪರಿಷ್ಕೃತ ಅಥವಾ ನವೀಕರಿಸಲಾದ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">“</font>
                </span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಸ್ಟರ್ ನಿರ್ದೇಶನ</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">” - </font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬ್ಯಾಂಕೇತರ ಹಣಕಾಸು ಕಂಪನಿ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">- </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಖಾತೆ ಸಂಗ್ರಾಹಕ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(Reserve Bank) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿರ್ದೇಶನಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 2016 ;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿರ್ದೇಶನಗಳ ಉದ್ದೇಶಕ್ಕಾಗಿ </span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗ್ರಾಹಕ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರೆ ನಮ್ಮಿಂದ ಒದಗಿಸಲಾದ ಸೇವೆಗಳನ್ನು ಪಡೆಯಲು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಸ್ಟರ್ ನಿರ್ದೇಶನಗಳ ಅಡಿಯಲ್ಲಿ ವ್ಯಾಖ್ಯಾನಿಸಲಾದ ಸೇವೆಗಳನ್ನು ಪಡೆಯಲು ನಮ್ಮೊಂದಿಗೆ ಒಪ್ಪಂದದಏರ್ಪಾಡನ್ನು &nbsp;ಮಾಡಿಕೊಂಡಿರುವ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">'</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವ್ಯಕ್ತಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">' </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರ್ಥ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                        <font face="Anek Kannada">”</font>
                    </span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಸ್ಟರ್ ನಿರ್ದೇಶನಗಳಲ್ಲಿ ನೀಡಲಾದ ಅದೇ ಅರ್ಥವನ್ನು ಹೊಂದಿರಬೇಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇದು ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರರೊಂದಿಗೆ ಲಭ್ಯವಿರುವ ನಿಮ್ಮ ಹಣಕಾಸಿನ ಡೇಟಾವನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರೆ ಬ್ಯಾಂಕ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬ್ಯಾಂಕಿಂಗ್ ಕಂಪನಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬ್ಯಾಂಕೇತರ ಹಣಕಾಸು ಕಂಪನಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಆಸ್ತಿ ನಿರ್ವಹಣಾ ಕಂಪನಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಠೇವಣಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಠೇವಣಿ ಭಾಗವಹಿಸುವವರು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿಮಾ ಕಂಪನಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿಮಾ ಭಂಡಾರ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪಿಂಚಣಿ ನಿಧಿ ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಸ್ಟರ್ ನಿರ್ದೇಶನಗಳಲ್ಲಿ </span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದು ಗುರುತಿಸಬಹುದಾದ ಇತರ ಘಟಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರೆ ಯಾವುದೇ ಹಣಕಾಸು ವಲಯ ನಿಯಂತ್ರಕರೊಂದಿಗೆ ನೋಂದಾಯಿಸಲ್ಪಟ್ಟ ಮತ್ತು ನಿಯಂತ್ರಿಸಲ್ಪಡುವ ಒಂದು ಘಟಕ ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಸ್ಟರ್ ನಿರ್ದೇಶನಗಳಲ್ಲಿ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದು ಗುರುತಿಸಬಹುದಾದ ಇತರ ಘಟಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ವಲಯ ನಿಯಂತ್ರಕ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂಬುದು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಸ್ಟರ್ ನಿರ್ದೇಶನಗಳಲ್ಲಿ ಅದಕ್ಕೆ ನೀಡಲಾದ ಅದೇ ಅರ್ಥವನ್ನು ಹೊಂದಿರುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ </span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವೈಯಕ್ತಿಕ ಡೇಟಾ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರೆ ಅಂತಹ ಡೇಟಾದಿಂದ ಅಥವಾ ಅದಕ್ಕೆ ಸಂಬಂಧಿಸಿದಂತೆ ಗುರುತಿಸಬಹುದಾದ ವ್ಯಕ್ತಿಯ ಬಗ್ಗೆ ಯಾವುದೇ ಡೇಟಾ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (h)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b style="mso-bidi-font-weight:normal">
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;">RBI</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">” </font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರೆ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Reserve Bank of India </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರ್ಥ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l6 level1 lfo2;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"Sandbox"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರೆ ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರರು ಮತ್ತು ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರರು ನಮ್ಮ ಕೊಡುಗೆಗಳನ್ನು ನಿರ್ಣಯಿಸಲು ಅನುವು ಮಾಡಿಕೊಡುವ ಪ್ಲಾಟ್ಫಾರ್ಮ್ ನ ಲಭ್ಯವಿರುವ ಪರೀಕ್ಷಾ ಪರಿಸರ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-align:justify;text-justify:inter-ideograph;">
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಯಮಗಳೊಳಗೆ ದೊಡ್ಡಕ್ಷರದಲ್ಲಿರುವ ಆದರೆ ಈ ಷರತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">1 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರಲ್ಲಿ ವ್ಯಾಖ್ಯಾನಿಸದ ಪದಗಳು ನಿರ್ದಿಷ್ಟ ಷರತ್ತುಗಳಲ್ಲಿ ಅವುಗಳಿಗೆ ನೀಡಲಾದ ಅರ್ಥವನ್ನು ಹೊಂದಿರುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        2.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವ್ಯಾಪ್ತಿ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಖಾತೆ ಒಟ್ಟುಗೂಡಿಸುವಿಕೆ ಸೇವೆಗಳು</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">": </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್ಫಾರ್ಮ್ ಮೂಲಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l9 level1 lfo4;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರರೊಂದಿಗೆ ಲಭ್ಯವಿರುವ ಹಣಕಾಸು ಮಾಹಿತಿಯನ್ನು ಹಿಂಪಡೆಯುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವೀಕ್ಷಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕ್ರೋಢೀಕರಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂಘಟಿಸುವುದು ಮತ್ತು ಹಂಚಿಕೊಳ್ಳುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮತ್ತು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l9 level1 lfo4;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಹಣಕಾಸು ಮಾಹಿತಿಯನ್ನು ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರರಿಗೆ ಪ್ರಸ್ತುತಪಡಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗ್ರಾಹಕರಿಗೆ ಪ್ಲಾಟ್ಫಾರ್ಮ್ ಗೆ ಪ್ರವೇಶವನ್ನು ಒದಗಿಸುವುದರ ಜೊತೆಗೆ ನಾವು ಪ್ಲಾಟ್ಫಾರ್ಮ್ ಮೂಲಕ ನೀಡುವ ಖಾತೆ ಒಟ್ಟುಗೂಡಿಸುವಿಕೆ ಸೇವೆಗಳನ್ನು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದು ಕರೆಯಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮಗೆ ಸೇವೆಗಳನ್ನು ಒದಗಿಸಲು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಷರತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">6 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರ ಪ್ರಕಾರ ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯೊಂದಿಗೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರರಿಂದ ನಿಮ್ಮ ಹಣಕಾಸಿನ ಮಾಹಿತಿಯನ್ನು ಪ್ರವೇಶಿಸಲು ಸೀಮಿತ ಅಧಿಕಾರ ಹೊಂದಿರುವ ಏಜೆಂಟ್ ಆಗಿ ನೀವು ಈ ಮೂಲಕ ನಮ್ಮನ್ನು ಅಧಿಕಾರ ನೀಡುತ್ತೀರಿ ಮತ್ತು ನೇಮಿಸುತ್ತೀರಿ ಮತ್ತು ನಿಮ್ಮ ಅವಶ್ಯಕತೆಗೆ ಅನುಗುಣವಾಗಿ ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರರೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.0500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l16 level1 lfo3;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ವಯವಾಗುವ ಕಾನೂನುಗಳಿಗೆ ಅನುಸಾರವಾಗಿ ಸೇವೆಗಳಿಗೆ ಶುಲ್ಕ ವಿಧಿಸುವ ಹಕ್ಕನ್ನು ನಾವು ಕಾಯ್ದಿರಿಸಿದ್ದೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾವು ಸೇವೆಗಳಿಗೆ ಶುಲ್ಕ ವಿಧಿಸಲು ಉದ್ದೇಶಿಸಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಶುಲ್ಕಗಳು ನಮ್ಮ ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ಲಭ್ಯವಿರುವ ನಮ್ಮ ಬೆಲೆ ನೀತಿಗೆ ಅನುಗುಣವಾಗಿರುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹೆಚ್ಚುವರಿಯಾಗಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಭವಿಷ್ಯದಲ್ಲಿ ಯಾವುದೇ ಶುಲ್ಕವನ್ನು ನಿರೀಕ್ಷಿತವಾಗಿ ವಿಧಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಈ ಸಂದರ್ಭದಲ್ಲಿ ನಿಮಗೆ ಲಿಖಿತ ಪೂರ್ವ ಸೂಚನೆಯನ್ನು ನೀಡಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರೊಫೈಲ್ ರಚನೆ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳನ್ನು ಪಡೆಯಲು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರೊಫೈಲ್</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರೊಫೈಲ್ ಅನ್ನು ರಚಿಸಬೇಕಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರೊಫೈಲ್ ರಚಿಸಲು ಬಳಕೆದಾರಹೆಸರು ಮತ್ತು ಪಾಸ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವರ್ಡ್ ಅನ್ನು ಹೊಂದಿಸುವುದರ ಜೊತೆಗೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ವಯವಾಗುವ ಕಾನೂನುಗಳಿಂದ ಅಗತ್ಯವಿರುವಂತೆ ಹೆಸರು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇಮೇಲ್ ವಿಳಾಸ ಮತ್ತು ಫೋನ್ ಸಂಖ್ಯೆಗಳನ್ನು ಒಳಗೊಂಡಂತೆ ಆದರೆ ಅವುಗಳಿಗೆ ಸೀಮಿತವಾಗಿರದೆ ಕೆಲವು ವಿವರಗಳನ್ನು ನೀವು ಒದಗಿಸಬೇಕಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಪ್ರೊಫೈಲ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಒದಗಿಸಲಾದ ಎಲ್ಲಾ ಮಾಹಿತಿಯು ನಿಖರ ಮತ್ತು ನಿಜವಾಗಿರುತ್ತದೆ ಎಂದು ನೀವು ಖಾತರಿಪಡಿಸುತ್ತೀರಿ ಮತ್ತು ಈ ಮಾಹಿತಿಯಲ್ಲಿ ಯಾವುದೇ ಬದಲಾವಣೆ ಅಥವಾ ಮಾರ್ಪಾಡು ಸಂಭವಿಸಿದಲ್ಲಿ ನೀವು ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ತಕ್ಷಣವೇ ನವೀಕರಿಸುತ್ತೀರಿ ಎಂದು ನೀವು ಒಪ್ಪುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:145%;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹ್ಯಾಂಡಲ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬಳಕೆದಾರಹೆಸರು ಮತ್ತು ಪಾಸ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವರ್ಡ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ ಸುರಕ್ಷತೆ ಮತ್ತು ಗೌಪ್ಯತೆಯನ್ನು ಕಾಪಾಡಿಕೊಳ್ಳುವ ಸಂಪೂರ್ಣ ಜವಾಬ್ದಾರಿ ನಿಮ್ಮದಾಗಿದೆ ಮತ್ತು ನಿಮ್ಮ ಪ್ರೊಫೈಲ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ ಯಾವುದೇ ಬಹಿರಂಗಪಡಿಸುವಿಕೆ ಅಥವಾ ಅನಧಿಕೃತ ಬಳಕೆ ಅಥವಾ ನಿಮ್ಮ ಪ್ರೊಫೈಲ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಯಾವುದೇ ಭದ್ರತಾ ಉಲ್ಲಂಘನೆಯ ಬಗ್ಗೆ ತಕ್ಷಣ ನಮಗೆ ತಿಳಿಸಲು ಒಪ್ಪುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(i) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ತಕ್ಷಣವೇ ನಮಗೆ ವರದಿ ಮಾಡುತ್ತೀರಿ ಮತ್ತು ನಿಮಗೆ ತಿಳಿದಿರುವ ಅಥವಾ ಅನುಮಾನಿಸುವ ಸೇವೆಗಳ ಯಾವುದೇ ಅನಧಿಕೃತ ಬಳಕೆಯನ್ನು ನಿಲ್ಲಿಸಲು ಸಮಂಜಸವಾದ ಪ್ರಯತ್ನಗಳನ್ನು ಮಾಡುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ii) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳನ್ನು ಪ್ರವೇಶಿಸಲು ಅಥವಾ ಬಳಸಲು ಸುಳ್ಳು ಗುರುತಿನ ಮಾಹಿತಿಯನ್ನು ಒದಗಿಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"AA </span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹ್ಯಾಂಡಲ್</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಂದರೆ ನಮ್ಮ ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ನಿಮ್ಮ ನೋಂದಣಿಯ ಸಮಯದಲ್ಲಿ ಉತ್ಪತ್ತಿಯಾಗುವ ವಿಶಿಷ್ಟ ಗುರುತಿಸುವಿಕೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇದನ್ನು ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್ ಅನ್ನು ಪ್ರವೇಶಿಸಲು ಮತ್ತು ಸೇವೆಗಳನ್ನು ಒದಗಿಸಲು ಪಕ್ಷಗಳು ಬಳಸುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l23 level1 lfo5;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಮೂಲಕ ನಡೆಯುವ ಎಲ್ಲಾ ಚಟುವಟಿಕೆಗಳಿಗೆ ನೀವು ಹೊಣೆಗಾರರಾಗಿರಲು ಮತ್ತು ಜವಾಬ್ದಾರರಾಗಿರಲು ಸ್ಪಷ್ಟವಾಗಿ ಒಪ್ಪುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಪ್ರೊಫೈಲ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗೆ ಯಾವುದೇ ಅನಧಿಕೃತ ಪ್ರವೇಶಕ್ಕೆ ನಾವು ಯಾವುದೇ ರೀತಿಯಲ್ಲಿ ಜವಾಬ್ದಾರರಾಗಿರುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಅನುಚಿತ ಬಳಕೆಯಿಂದ ನೇರವಾಗಿ ಅಥವಾ ಪರೋಕ್ಷವಾಗಿ ಉಂಟಾಗುವ ಯಾವುದೇ ಡೇಟಾ ಅಥವಾ ಕ್ರಿಯಾತ್ಮಕತೆಯ ನಷ್ಟಕ್ಕೆ ನಾವು ಜವಾಬ್ದಾರರಾಗಿರುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;text-indent:7.0000pt;
tab-stops:left blank 21.1500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l7 level2 lfo6;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.1<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:157%;
mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳ ಕೆಲವು ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಪಡೆಯಲು ಉದ್ದೇಶಿಸಿರುವ ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ ಬಳಕೆದಾರರಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ನಾವು ಕೆಲವು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಗ್ರಾಹಕರನ್ನು ತಿಳಿದುಕೊಳ್ಳಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರಕ್ರಿಯೆಗಳನ್ನು ಕೈಗೊಳ್ಳಬೇಕಾಗಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಟ್ಟಿನಲ್ಲಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಾಲಕಾಲಕ್ಕೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳ ಕೆಲವು ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"KYC </span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದಾಖಲೆಗಳು</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬಳಸಲು ನಿಮ್ಮ ಅರ್ಹತೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ಅಗತ್ಯವಿರುವ ಮಾಹಿತಿ ಮತ್ತು ದಾಖಲೆಗಳನ್ನು ಅಪ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಲೋಡ್ ಮಾಡಲು ನಾವು ನಿಮ್ಮನ್ನು ಕೇಳುತ್ತೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದಾಖಲೆಗಳನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲು ಮತ್ತು ನಿಮ್ಮ ಅರ್ಹತೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ನೀವು ನಮಗೆ ಮತ್ತು ನಾವು ತೊಡಗಿಸಿಕೊಳ್ಳಬಹುದಾದ ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಸೇವಾ ಪೂರೈಕೆದಾರರಿಗೆ ಅಧಿಕಾರ ನೀಡುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾವು ಕೈಗೊಳ್ಳುವ ಯಾವುದೇ ಪ್ರಕ್ರಿಯೆಯು ನಮ್ಮ ಗೌಪ್ಯತಾ ನೀತಿಗೆ ಅನುಗುಣವಾಗಿರುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ಷರತ್ತಿನ ಅಡಿಯಲ್ಲಿ ಮೂರನೇ ವ್ಯಕ್ತಿಯು ಮಾಹಿತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಿದರೆ ನೀವು ಹೆಚ್ಚುವರಿ ಸೇವಾ ನಿಯಮಗಳಿಗೆ ಒಳಪಟ್ಟಿರಬಹುದು ಎಂದು ನೀವು ಒಪ್ಪುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇದಲ್ಲದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅರ್ಹತೆಯನ್ನು ನಿರ್ಧರಿಸಲು ಯಾವುದೇ ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಡೇಟಾ ಅಥವಾ ದಸ್ತಾವೇಜನ್ನು ಅಗತ್ಯವಿದ್ದರೆ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಒಟ್ಟಾರೆಯಾಗಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">), </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿನಂತಿಯ ಮೇರೆಗೆ ಅಂತಹ ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿಯನ್ನು ತಕ್ಷಣವೇ ಹಂಚಿಕೊಳ್ಳಲು ನೀವು ಈ ಮೂಲಕ ಒಪ್ಪುತ್ತೀರಿ ಮತ್ತು ಇದಲ್ಲದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂತಹ ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲು ನಮಗೆ ಅಧಿಕಾರ ನೀಡುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:144%;
mso-list:l5 level1 lfo7;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ನಿಜವಾದ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂಪೂರ್ಣ ಮತ್ತು ನವೀಕೃತ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದಾಖಲೆಗಳು ಮತ್ತು ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿಯನ್ನು ಒದಗಿಸಲು ಒಪ್ಪುತ್ತೀರಿ ಮತ್ತು ಖಾತರಿ ನೀಡುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. (i) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಟ್ಟಿನಲ್ಲಿ ಒದಗಿಸಲಾದ ಯಾವುದೇ ಸುಳ್ಳು ಅಥವಾ ದಾರಿತಪ್ಪಿಸುವ ಮಾಹಿತಿಯು ಈ ನಿಯಮಗಳ ಉಲ್ಲಂಘನೆಯಾಗುತ್ತದೆ ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ii) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">KYC </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದಾಖಲೆಗಳು ಮತ್ತು ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿಯನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ವಿಫಲವಾದರೆ ಸೇವೆಗಳ ಕೆಲವು ವೈಶಿಷ್ಟ್ಯಗಳಿಗೆ ನಿಮ್ಮ ಪ್ರವೇಶವನ್ನು ಸೀಮಿತಗೊಳಿಸಬಹುದು ಅಥವಾ ನಿರಾಕರಿಸಬಹುದು ಎಂದು ನೀವು ಮತ್ತಷ್ಟು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;text-indent:7.0000pt;
tab-stops:left blank 21.1500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l7 level2 lfo6;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        3.2<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಡೇಟಾ ಬಳಸಲು ಒಪ್ಪಿಗೆ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಯಾವುದೇ ಹಣಕಾಸಿನ ಮಾಹಿತಿಯನ್ನು ನಾವು ಸಂಗ್ರಹಿಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರವೇಶಿಸುವುದಿಲ್ಲ ಅಥವಾ ನೋಡುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. ReBIT (Reserve Bank </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಹಿತಿ ತಂತ್ರಜ್ಞಾನ ಪ್ರೈವೇಟ್ ಲಿಮಿಟೆಡ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವ್ಯಾಖ್ಯಾನಿಸಿದ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">NBFC-AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ತಾಂತ್ರಿಕ ವಿಶೇಷಣಗಳ ಪ್ರಕಾರ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರೊಫೈಲ್ ಅನ್ನು ರಚಿಸಲು ಮತ್ತು ನಿಮ್ಮ ಹಣಕಾಸು ಖಾತೆಗಳನ್ನು ಕಂಡುಹಿಡಿಯಲು ನಿಮಗೆ ಸಹಾಯ ಮಾಡಲು ನಾವು ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಸಂಗ್ರಹಿಸಿ ಪರಿಶೀಲಿಸುತ್ತೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಸಮ್ಮತಿಗೆ ಸಂಬಂಧಿಸಿದ ಕ್ರಿಯೆಗಳ ಕುರಿತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">SMS </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಧಿಸೂಚನೆಗಳನ್ನು ಕಳುಹಿಸಲು ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಎನ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕ್ರಿಪ್ಟ್ ಮಾಡಿದ ಸ್ವರೂಪದಲ್ಲಿ ಸುರಕ್ಷಿತವಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹೆಚ್ಚುವರಿಯಾಗಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">FIP </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಗತ್ಯವಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, FIP </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಲಿಂಕ್ ಮಾಡಲಾದ ನಿಖರವಾದ ಖಾತೆಗಳನ್ನು ಕಂಡುಹಿಡಿಯಲು ಸಹಾಯ ಮಾಡಲು ನಿಮ್ಮ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">PAN </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮತ್ತು ಜನ್ಮ ದಿನಾಂಕವನ್ನು ಮಾಸ್ಕ್ಡ್ ರೂಪದಲ್ಲಿ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(ReBIT </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಂದ ಪ್ರಕಟಿಸಲಾದ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">NBFC-AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ತಾಂತ್ರಿಕ ವಿಶೇಷಣಗಳ ಪ್ರಕಾರ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) Finvu AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವ್ಯವಸ್ಥೆಯ ಮೂಲಕ ರವಾನಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. PAN </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮತ್ತು ಜನ್ಮ ದಿನಾಂಕವನ್ನು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Finvu AA </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ಸಂಗ್ರಹಿಸಲಾಗುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 19.0500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:144%;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಸೇವೆಗಳ ನಿಬಂಧನೆಯು ನಿಮ್ಮ ಹಣಕಾಸಿನ ಮಾಹಿತಿಯನ್ನು ಬಹಿರಂಗಪಡಿಸಲು ಮತ್ತು ವರ್ಗಾಯಿಸಲು ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ನೀಡಲು ನಿಮಗೆ ಅನುವು ಮಾಡಿಕೊಡುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಮ್ಮತಿ ಕಲಾಕೃತಿಯ ಬಳಕೆಯ ಮೂಲಕ ಸಮ್ಮತಿಯನ್ನು ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ದೃಢೀಕರಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇದಕ್ಕಾಗಿ ನೀವು ಈ ಕೆಳಗಿನ ಡೇಟಾಸೆಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳನ್ನು ದೃಢೀಕರಿಸಬೇಕಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 22.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಗುರುತು ಮತ್ತು ಐಚ್ಛಿಕ ಸಂಪರ್ಕ ಮಾಹಿತಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 23.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿನಂತಿಸಿದ ಹಣಕಾಸು ಮಾಹಿತಿಯ ಸ್ವರೂಪ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂತಹ ಮಾಹಿತಿಯನ್ನು ಸಂಗ್ರಹಿಸುವ ಉದ್ದೇಶ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 212.75pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಹಿತಿ ಸ್ವೀಕರಿಸುವವರ ಗುರುತು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 23.3000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾಹಿತಿಯನ್ನು ಪ್ರವೇಶಿಸಲು ಸಮ್ಮತಿ ಕಲಾಕೃತಿಯನ್ನು ಬಳಸುವಾಗಲೆಲ್ಲಾ ಅಧಿಸೂಚನೆಯನ್ನು ಕಳುಹಿಸಬೇಕಾದ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">URL </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ ಇತರ ವಿಳಾಸ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಒಪ್ಪಿಗೆ ರಚನೆ ದಿನಾಂಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಒಪ್ಪಿಗೆಯ ಮುಕ್ತಾಯ ದಿನಾಂಕ ಮತ್ತು ನಿಮ್ಮ ಸಹಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಡಿಜಿಟಲ್ ಸಹಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l18 level1 lfo9;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ವಯವಾಗುವ ಕಾನೂನಿನ ಅಡಿಯಲ್ಲಿ ಅಗತ್ಯವಿರುವ ಯಾವುದೇ ಇತರ ಮಾಹಿತಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮಗೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ಹಣಕಾಸಿನ ಮಾಹಿತಿಯನ್ನು ಪಡೆಯಲು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಮ್ಮತಿ ಕಲಾಕೃತಿಯ ಮೂಲಕ ನಮಗೆ ಒದಗಿಸಲಾದ ನಿಮ್ಮ ಎಲ್ಲಾ ಅಥವಾ ಯಾವುದೇ ಸಮ್ಮತಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳನ್ನು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಹಿಂತೆಗೆದುಕೊಳ್ಳಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರದ್ದತಿಯ ನಂತರ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ ಒದಗಿಸುವವರು ಮತ್ತು ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರರಿಗೆ ಅಂತಹ ಅಧಿಸೂಚನೆಯ ಬಗ್ಗೆ ತಿಳಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:7.0000pt;tab-stops:left blank 18.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಮತ್ತು ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ಮಾಹಿತಿಯನ್ನು ಹಂಚಿಕೊಂಡಿರುವ ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರರು ಒದಗಿಸಿದ ಒಪ್ಪಿಗೆಗಳ ದಾಖಲೆಯನ್ನು ನೀವು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಪ್ರವೇಶಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;text-indent:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಗೌಪ್ಯತಾ ನೀತಿಗೆ ಅನುಸಾರವಾಗಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ ಮತ್ತು ತಾಂತ್ರಿಕ ಡೇಟಾ ಮತ್ತು ಸಂಬಂಧಿತ ಮಾಹಿತಿಯನ್ನು ನಾವು ಸಂಗ್ರಹಿಸಬಹುದು ಮತ್ತು ಬಳಸಬಹುದು ಎಂದು ನೀವು ಒಪ್ಪುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-left:7.0000pt;tab-stops:left blank 17.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ ಪರಿಣಾಮಕಾರಿತ್ವ ಮತ್ತು ದಕ್ಷತೆಯನ್ನು ಮತ್ತಷ್ಟು ಹೆಚ್ಚಿಸಲು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿಶ್ಲೇಷಣೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರವೃತ್ತಿಗಳ ಗುರುತಿಸುವಿಕೆ ಮತ್ತು ಅಂಕಿಅಂಶಗಳಿಗಾಗಿ ನಾವು ಹಣಕಾಸು ಮಾಹಿತಿ ಮತ್ತು ಸೇವೆಗಳು ಮತ್ತು ಚಟುವಟಿಕೆಗಳ ನಿಮ್ಮ ಬಳಕೆಗೆ ಸಂಬಂಧಿಸಿದ ಡೇಟಾವನ್ನು ಹೊರತುಪಡಿಸಿ ಮಾಹಿತಿಯನ್ನು ಬಳಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:7.0000pt;
tab-stops:left blank 18.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l20 level1 lfo8;">
                <![if !supportLists]>
                <span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ವಯವಾಗುವ ಕಾನೂನುಗಳಿಗೆ ಒಳಪಟ್ಟು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕ್ರಿಮಿನಲ್ ಮೊಕದ್ದಮೆಗಳು ಅಥವಾ ಯಾವುದೇ ಇತರ ಮೊಕದ್ದಮೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ನಿಮಗೆ ಸಂಬಂಧಿಸಿದ ಡೇಟಾವನ್ನು ಬಹಿರಂಗಪಡಿಸಲು ಕಾನೂನು ಜಾರಿ ಸಂಸ್ಥೆಗಳು ಅಥವಾ ಸರ್ಕಾರ ಮತ್ತು ಸಂಬಂಧಿತ ನಿಯಂತ್ರಕ ಸಂಸ್ಥೆಗಳು ನಮಗೆ ನಿರ್ದೇಶನ ನೀಡಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂತಹ ಸಂದರ್ಭಗಳಲ್ಲಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂಬಂಧಿತ ಏಜೆನ್ಸಿಗಳು ಅಥವಾ ಸಂಸ್ಥೆಗಳೊಂದಿಗೆ ಅಂತಹ ಡೇಟಾವನ್ನು ಹಂಚಿಕೊಳ್ಳುವ ಹಕ್ಕು ನಮಗಿರುತ್ತದೆ ಎಂಬುದನ್ನು ನೀವು ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೀರಿ ಮತ್ತು ಒಪ್ಪುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        4.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಧಿಸೂಚನೆಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಂಪನಿಯು ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್ ಐಡಿ ಅಥವಾ ಫೋನ್ ಸಂಖ್ಯೆಗೆ ಕಾಲಕಾಲಕ್ಕೆ ಸೂಚನೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂವಹನಗಳು ಅಥವಾ ಎಚ್ಚರಿಕೆಗಳನ್ನು ಕಳುಹಿಸಬಹುದು ಮತ್ತು ಸೇವೆಗಳನ್ನು ಒದಗಿಸಲು ಅಗತ್ಯವಾದ ಅಗತ್ಯ ಸಂವಹನಗಳಿಂದ ಹೊರಗುಳಿಯಲು ನಿಮಗೆ ಸಾಧ್ಯವಾಗದಿರಬಹುದು ಎಂದು ನೀವು ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಎಚ್ಚರಿಕೆಗಳು ಅಥವಾ ಸಂವಹನದ ಸ್ವೀಕೃತಿಯನ್ನು ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳ ಅತ್ಯುತ್ತಮ ಬಳಕೆಗಾಗಿ ಅದನ್ನು ಪರಿಷ್ಕರಿಸಲು ಮತ್ತು ಎಚ್ಚರಿಕೆಗಳ ಸ್ವೀಕೃತಿಯನ್ನು ಅದರ ಸರಿಯಾದ ಗಮ್ಯಸ್ಥಾನಕ್ಕೆ ಸಕ್ರಿಯಗೊಳಿಸಲು ಕಂಪನಿಯು ಶಿಫಾರಸು ಮಾಡುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l17 level1 lfo10;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಂಪನಿಯಿಂದ ಬರುವ ಸಂವಹನಗಳು ಸೇವೆಗಳಿಗೆ ಮಾತ್ರ ಸಂಬಂಧಿಸಿರುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        5.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಬಾಧ್ಯತೆಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಸ್ಪಷ್ಟ ಒಪ್ಪಿಗೆಯ ಆಧಾರದ ಮೇಲೆ ನಾವು ನಿಮಗೆ ಸೇವೆಗಳನ್ನು ಒದಗಿಸುತ್ತೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮಗೆ ಸೇವೆಗಳನ್ನು ಒದಗಿಸುವುದು ನಮ್ಮ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಮತ್ತು ಹಣಕಾಸು ಮಾಹಿತಿ ಬಳಕೆದಾರರ ನಡುವಿನ ಸೂಕ್ತ ಒಪ್ಪಂದಗಳು ಮತ್ತು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ ಅಧಿಕಾರಗಳಿಂದ ಬೆಂಬಲಿತವಾಗಿದೆ ಎಂದು ನಾವು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳುತ್ತೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮಗೆ ಸಂಬಂಧಿಸಿದ ಮತ್ತು ಸೇವೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ನಾವು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಬಹುದಾದ ಯಾವುದೇ ಹಣಕಾಸು ಮಾಹಿತಿಯನ್ನು ನಾವು ಸಂಗ್ರಹಿಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಖಾತೆ ಒಟ್ಟುಗೂಡಿಸುವಿಕೆಯ ವ್ಯವಹಾರವನ್ನು ಕೈಗೊಳ್ಳಲು ನಾವು ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಸೇವಾ ಪೂರೈಕೆದಾರರ ಸೇವೆಗಳನ್ನು ಬಳಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l15 level1 lfo11;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿವಿಧ ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರರೊಂದಿಗಿನ ಖಾತೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ನಿಮ್ಮ ಬಳಕೆದಾರ ದೃಢೀಕರಣ ರುಜುವಾತುಗಳನ್ನು ನಾವು ಪ್ರವೇಶಿಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        6.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಜವಾಬ್ದಾರಿಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳಿಗೆ ಒಪ್ಪಿಗೆ ನೀಡುವ ದಿನಾಂಕದಂದು ಸೇವೆಗಳ ಮೂಲಕ ಅಥವಾ ಅವುಗಳಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಒದಗಿಸಲಾದ ಎಲ್ಲಾ ಮಾಹಿತಿಯು ಸಂಪೂರ್ಣ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸತ್ಯ ಮತ್ತು ಸರಿಯಾಗಿದೆ ಮತ್ತು ನೀವು ಸೇವೆಗಳನ್ನು ಪಡೆಯುವವರೆಗೆ ಸಂಪೂರ್ಣ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸತ್ಯ ಮತ್ತು ಸರಿಯಾಗಿ ಮುಂದುವರಿಯುತ್ತದೆ ಎಂದು ನೀವು ಪ್ರತಿನಿಧಿಸುತ್ತೀರಿ ಮತ್ತು ಖಾತರಿಪಡಿಸುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಅಸ್ತಿತ್ವದಲ್ಲಿರುವ ಸಮಯದಲ್ಲಿ ನೀವು ಒದಗಿಸುವ ಯಾವುದೇ ಮಾಹಿತಿಯು ಬದಲಾದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂತಹ ಬದಲಾವಣೆಯನ್ನು ತಕ್ಷಣವೇ ನಮ್ಮ ಗಮನಕ್ಕೆ ತರಲು ಮತ್ತು ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಮೂಲಕ ಅದನ್ನು ತ್ವರಿತವಾಗಿ ನವೀಕರಿಸಲು ನೀವು ಕೈಗೊಳ್ಳುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್ ಮೂಲಕ ನೀವು ರವಾನಿಸುವ ಮಾಹಿತಿಯ ವಿಷಯದ ಮೇಲೆ ನಾವು ಯಾವುದೇ ನಿಯಂತ್ರಣವನ್ನು ಹೊಂದಿಲ್ಲ ಎಂದು ನೀವು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳನ್ನು ಪಡೆಯಲು ಒದಗಿಸಲಾದ ಯಾವುದೇ ಮಾಹಿತಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದಸ್ತಾವೇಜನ್ನು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಸ್ತು ಅಥವಾ ಡೇಟಾ ತಪ್ಪಾಗಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಪೂರ್ಣವಾಗಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಖರವಾಗಿಲ್ಲದಿದ್ದರೆ ಅಥವಾ ದಾರಿತಪ್ಪಿಸುತ್ತಿದ್ದರೆ ಅಥವಾ ನೀವು ಯಾವುದೇ ವಸ್ತು ಸಂಗತಿಯನ್ನು ಬಹಿರಂಗಪಡಿಸಲು ವಿಫಲವಾದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಅನುಭವಿಸಬಹುದಾದ ಅಥವಾ ಆಗಬಹುದಾದದ ಯಾವುದೇ ನಷ್ಟ ಅಥವಾ ಹಾನಿಗೆ ನಾವು ಯಾವುದೇ ಜವಾಬ್ದಾರಿ ಅಥವಾ ಹೊಣೆಗಾರಿಕೆಯನ್ನು ಸ್ವೀಕರಿಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ವಯವಾಗುವ ಕಾನೂನುಗಳ ಅನುಸರಣೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ಸಂಪೂರ್ಣ ಜವಾಬ್ದಾರರಾಗಿರುತ್ತೀರಿ ಮತ್ತು ಈ ನಿಟ್ಟಿನಲ್ಲಿ ನಿಮ್ಮ ಬಾಧ್ಯತೆಗಳ ಉಲ್ಲಂಘನೆಯಿಂದ ಉಂಟಾಗಬಹುದಾದ ಯಾವುದೇ ಹೊಣೆಗಾರಿಕೆಗೆ ಸಂಪೂರ್ಣ ಹೊಣೆಗಾರರಾಗಿರುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l0 level1 lfo12;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಅಡಿಯಲ್ಲಿ ನಿಮ್ಮ ಬಾಧ್ಯತೆಗಳು ಅಥವಾ ಒಪ್ಪಂದಗಳ ಉಲ್ಲಂಘನೆಯಿಂದಾಗಿ ನಮ್ಮ ವಿರುದ್ಧ ಪ್ರಾರಂಭಿಸಬಹುದಾದ ಯಾವುದೇ ಪ್ರಕ್ರಿಯೆಗಳ ರಕ್ಷಣೆಯಲ್ಲಿ ನೀವು ನಮಗೆ ಎಲ್ಲಾ ಸಹಕಾರವನ್ನು ನೀಡಬೇಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        7.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಷೇಧಿತ ಚಟುವಟಿಕೆಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l13 level1 lfo13;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳಲ್ಲಿ ಸ್ಪಷ್ಟವಾಗಿ ಅನುಮತಿಸಲಾದ ಹೊರತುಪಡಿಸಿ ನೀವು ಯಾವುದೇ ರೀತಿಯಲ್ಲಿ ಸೇವೆಗಳನ್ನು ಬಳಸಬಾರದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಿಂದಿನ ವಾಕ್ಯದ ಸಾಮಾನ್ಯತೆಯನ್ನು ಸೀಮಿತಗೊಳಿಸದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗೆ ನಕಲಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾರ್ಪಡಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಳವಡಿಸಿಕೊಳ್ಳುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನುವಾದಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರಿವರ್ಸ್ ಎಂಜಿನಿಯರ್ ಮಾಡುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಡಿಕಂಪೈಲ್ ಮಾಡುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಡಿಸ್ಅಸೆಂಬಲ್ ಮಾಡುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾರ್ಪಡಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪುನರುತ್ಪಾದಿಸುವುದು ಅಥವಾ ಯಾವುದೇ ವ್ಯುತ್ಪನ್ನ ಕೃತಿಗಳನ್ನು ರಚಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇಲ್ಲಿ ಸ್ಪಷ್ಟವಾಗಿ ಒದಗಿಸಲಾದ ಹೊರತುಪಡಿಸಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಗೆ ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ ಕ್ರಿಯಾತ್ಮಕತೆಯನ್ನು ಪ್ರವೇಶಿಸಲು ಅಥವಾ ಪ್ರಯೋಜನ ಪಡೆಯಲು ಅನುಮತಿಸುವುದನ್ನು ಹೊರತುಪಡಿಸಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಸ್ಪರ್ಧಾತ್ಮಕ ಅಥವಾ ಅಂತಹುದೇ ಉತ್ಪನ್ನವನ್ನು ಅಭಿವೃದ್ಧಿಪಡಿಸಲು ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್ ಅನ್ನು ಬಳಸಿಕೊಂಡು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಮಯ ಹಂಚಿಕೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾನದಂಡ ಅಥವಾ ಇತರ ಕಂಪ್ಯೂಟರ್ ಸೇವೆಗಳನ್ನು ಮೂರನೇ ವ್ಯಕ್ತಿಗಳಿಗೆ ಒದಗಿಸಲು ಯಾವುದೇ ಮೇಮರ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್ ಅನ್ನು ಬಳಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಕಂಪ್ಯೂಟರ್ ಸಾಫ್ಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವೇರ್ ಅಥವಾ ಹಾರ್ಡ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವೇರ್ ಕಾರ್ಯಾಚರಣೆಯ ಮೇಲೆ ಪ್ರತಿಕೂಲ ಪರಿಣಾಮ ಬೀರುವಂತೆ ಅಥವಾ ಯಾವುದೇ ಕಂಪ್ಯೂಟರ್ ಸಂಪನ್ಮೂಲದ ಕಾರ್ಯವನ್ನು ನಾಶಪಡಿಸಲು ಅಥವಾ ಮಿತಿಗೊಳಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ವೈರಸ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಟ್ರೋಜನ್ ಹಾರ್ಸ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಟೈಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬಾಂಬ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕೀಸ್ಟ್ರೋಕ್ ಲಾಗರ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸ್ಪೈವೇರ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಆಡ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವೇರ್ ಅಥವಾ ಯಾವುದೇ ಇತರ ಹಾನಿಕಾರಕ ಪ್ರೋಗ್ರಾಂಗಳು ಅಥವಾ ಅಂತಹುದೇ ಕಂಪ್ಯೂಟರ್ ಕೋಡ್ ಅನ್ನು ಒಳಗೊಂಡಿರುವ ಯಾವುದೇ ಡೇಟಾವನ್ನು ರವಾನಿಸಲು ಅಥವಾ ಕಳುಹಿಸಲು ಅಥವಾ ಅಪ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಲೋಡ್ ಮಾಡಲು ಸೇವೆಗಳನ್ನು ಬಳಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 12.5000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್ ಅಥವಾ ಅದರ ಯಾವುದೇ ಭಾಗವನ್ನು ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡಲು ಅಥವಾ ನಕಲಿಸಲು ಯಾವುದೇ ರೋಬೋಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸ್ಪೈಡರ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇತರ ಸ್ವಯಂಚಾಲಿತ ಸಾಧನ ಅಥವಾ ಹಸ್ತಚಾಲಿತ ಪ್ರಕ್ರಿಯೆಯನ್ನು ಬಳಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಪೇಟೆಂಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಟ್ರೇಡ್ಮಾರ್ಕ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಕ್ಕುಸ್ವಾಮ್ಯ ಅಥವಾ ಇತರ ಸ್ವಾಮ್ಯದ ಹಕ್ಕುಗಳನ್ನು ಉಲ್ಲಂಘಿಸುವುದು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವ್ಯಕ್ತಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಧಿಕಾರಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿರ್ದೇಶಕರು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಉದ್ಯೋಗಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಏಜೆಂಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಧಿಕೃತ ಪ್ರತಿನಿಧಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವೇದಿಕೆ ನಾಯಕರು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾರ್ಗದರ್ಶಕರು ಅಥವಾ ಹೋಸ್ಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳು ಸೇರಿದಂತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಆದರೆ ಇವುಗಳಿಗೆ ಸೀಮಿತವಾಗಿರದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ವ್ಯಕ್ತಿ ಅಥವಾ ಘಟಕದಂತೆ ಸೋಗು ಹಾಕುವುದು ಅಥವಾ ತಪ್ಪಾಗಿ ಪ್ರತಿನಿಧಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ ಯಾವುದೇ ಮಾಹಿತಿ ಅಥವಾ ಖಾತೆಗಳನ್ನು ತಪ್ಪಾಗಿ ಹೇಳುವುದು ಅಥವಾ ತಪ್ಪಾಗಿ ಪ್ರತಿನಿಧಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 13.9500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂದೇಶದ ಮೂಲದ ಬಗ್ಗೆ ವಿಳಾಸದಾರರನ್ನು ಮೋಸಗೊಳಿಸುವುದು ಅಥವಾ ದಾರಿ ತಪ್ಪಿಸುವುದು ಅಥವಾ ತಿಳಿದೂ ಮತ್ತು ಉದ್ದೇಶಪೂರ್ವಕವಾಗಿ ಯಾವುದೇ ತಪ್ಪು ಮಾಹಿತಿ ಅಥವಾ ಮಾಹಿತಿಯನ್ನು ಸಂವಹನ ಮಾಡುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅದು ಸ್ಪಷ್ಟವಾಗಿ ಸುಳ್ಳು ಮತ್ತು ಸುಳ್ಳು ಅಥವಾ ದಾರಿತಪ್ಪಿಸುವ ಸ್ವಭಾವವನ್ನು ಹೊಂದಿದೆ ಅಥವಾ ಕೇಂದ್ರ ಸರ್ಕಾರದ ಯಾವುದೇ ವ್ಯವಹಾರಕ್ಕೆ ಸಂಬಂಧಿಸಿದಂತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಚಿವಾಲಯವು ಅಧಿಕೃತ ಗೆಜೆಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ಪ್ರಕಟಿಸಲಾದ ಅಧಿಸೂಚನೆಯ ಮೂಲಕ ಕೇಂದ್ರ ಸರ್ಕಾರದ ಸತ್ಯ ಪರಿಶೀಲನಾ ಘಟಕವು ನಕಲಿ ಅಥವಾ ಸುಳ್ಳು ಅಥವಾ ದಾರಿತಪ್ಪಿಸುವ ಎಂದು ಗುರುತಿಸಿದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 15.1500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (viii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಭಾರತದ ಏಕತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಮಗ್ರತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರಕ್ಷಣೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಭದ್ರತೆ ಅಥವಾ ಸಾರ್ವಭೌಮತ್ವ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿದೇಶಿ ರಾಜ್ಯಗಳೊಂದಿಗಿನ ಸ್ನೇಹ ಸಂಬಂಧಗಳು ಅಥವಾ ಸಾರ್ವಜನಿಕ ಸುವ್ಯವಸ್ಥೆಗೆ ಬೆದರಿಕೆ ಹಾಕುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ ಯಾವುದೇ ಸಂಜ್ಞೇಯ ಅಪರಾಧವನ್ನು ಮಾಡಲು ಪ್ರಚೋದನೆ ನೀಡುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ ಯಾವುದೇ ಅಪರಾಧದ ತನಿಖೆಯನ್ನು ತಡೆಯುವುದು ಅಥವಾ ಇತರ ರಾಷ್ಟ್ರವನ್ನು ಅವಮಾನಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ix)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇನ್ನೊಬ್ಬ ವ್ಯಕ್ತಿಯಂತೆ ನಟಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.3000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (x)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಾಫ್ಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವೇರ್ ವೈರಸ್ ಅಥವಾ ಅಡ್ಡಿಪಡಿಸಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ಯಾವುದೇ ಇತರ ಕಂಪ್ಯೂಟರ್ ಕೋಡ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫೈಲ್ ಅಥವಾ ಪ್ರೋಗ್ರಾಂ ಅನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">,</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೇರವಾಗಿ ಅಥವಾ ಪರೋಕ್ಷವಾಗಿ ಸಂಗ್ರಹ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂಕಲನ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಡೇಟಾಬೇಸ್ ಅಥವಾ ಡೈರೆಕ್ಟರಿಯನ್ನು ರಚಿಸಲು ಅಥವಾ ಸಂಕಲಿಸಲು ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಂದ ವಿಷಯವನ್ನು ವ್ಯವಸ್ಥಿತವಾಗಿ ಮರುಪಡೆಯುವಲ್ಲಿ ತೊಡಗಿಸಿಕೊಳ್ಳಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 13.9500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳನ್ನು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(A) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಕಾನೂನುಬಾಹಿರ ರೀತಿಯಲ್ಲಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, (B) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮೋಸದ ಅಥವಾ ದುರುದ್ದೇಶಪೂರಿತ ಚಟುವಟಿಕೆಗಳಿಗೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(C) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳಿಗೆ ಹೊಂದಿಕೆಯಾಗದ ಯಾವುದೇ ರೀತಿಯಲ್ಲಿ ಬಳಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 15.1500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l1 level1 lfo14;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (xiii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ವಯವಾಗುವ ಕಾನೂನುಗಳನ್ನು ಯಾವುದೇ ರೀತಿಯಲ್ಲಿ ಉಲ್ಲಂಘಿಸುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l12 level1 lfo15;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್ ಪ್ರವೇಶಕ್ಕೆ ಅಡ್ಡಿಪಡಿಸುವ ಅಥವಾ ಅಡ್ಡಿಪಡಿಸುವ ಯಾವುದೇ ಚಟುವಟಿಕೆಯಲ್ಲಿ ನೀವು ತೊಡಗಿಸಿಕೊಳ್ಳಬಾರದು ಎಂದು ನೀವು ಖಾತರಿಪಡಿಸುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.5500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:144%;
mso-list:l12 level1 lfo15;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ ಯಾವುದೇ ಭಾಗ ಅಥವಾ ವೈಶಿಷ್ಟ್ಯಕ್ಕೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗೆ ಸಂಪರ್ಕಗೊಂಡಿರುವ ಯಾವುದೇ ಇತರ ವ್ಯವಸ್ಥೆಗಳು ಅಥವಾ ನೆಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವರ್ಕ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳಿಗೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಯಾವುದೇ ಸರ್ವರ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಳಿಗೆ ಅಥವಾ ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್ ಮೂಲಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹ್ಯಾಕಿಂಗ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪಾಸ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವರ್ಡ್ ಮೈನಿಂಗ್ ಅಥವಾ ಯಾವುದೇ ಇತರ ಕಾನೂನುಬಾಹಿರ ವಿಧಾನಗಳ ಮೂಲಕ ಅನಧಿಕೃತ ಪ್ರವೇಶವನ್ನು ಪಡೆಯಲು ನೀವು ಪ್ರಯತ್ನಿಸಬಾರದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        8.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬೌದ್ಧಿಕ ಆಸ್ತಿ ಹಕ್ಕುಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಂದ ಉಂಟಾಗುವ ಎಲ್ಲಾ ಬೌದ್ಧಿಕ ಆಸ್ತಿ ಹಕ್ಕುಗಳನ್ನು ಒಳಗೊಂಡಂತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿನ ಎಲ್ಲಾ ಹಕ್ಕುಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಶೀರ್ಷಿಕೆ ಮತ್ತು ಆಸಕ್ತಿಯು ನಮ್ಮ ಒಡೆತನದಲ್ಲಿದೆ ಅಥವಾ ನಮಗೆ ಪರವಾನಗಿ ನೀಡಲಾಗಿದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಅನುಸರಣೆಗೆ ಒಳಪಟ್ಟು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳು ಮತ್ತು ಕಾಲಕಾಲಕ್ಕೆ ನೀಡಲಾಗುವ ಅದರ ಲಿಖಿತ ಸೂಚನೆಗಳಿಗೆ ಅನುಸಾರವಾಗಿ ಪ್ಲಾಟ್ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ನು ಬಳಸಲು ನಾವು ನಿಮಗೆ ವಿಶೇಷವಲ್ಲದ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವರ್ಗಾಯಿಸಲಾಗದ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಉಪ ಪರವಾನಗಿ ಪಡೆಯಲಾಗದ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರಾಯಲ್ಟಿ ಮುಕ್ತ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಿಂತೆಗೆದುಕೊಳ್ಳಬಹುದಾದ ಮತ್ತು ಸೀಮಿತ ಪರವಾನಗಿಯನ್ನು ನೀಡುತ್ತೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.0500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:144%;
mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫಾರ್ಮ್ ಅಥವಾ ಸೇವೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರತಿಕ್ರಿಯೆ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದೋಷ ವರದಿಗಳು ಸೇರಿದಂತೆ ಸಲಹೆಗಳು ಮತ್ತು ಇತರ ಪ್ರತಿಕ್ರಿಯೆಗಳನ್ನು ಸಲ್ಲಿಸಲು ನಾವು ನಿಮ್ಮನ್ನು ವಿನಂತಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂತಹ ಪ್ರತಿಕ್ರಿಯೆಯ ಎಲ್ಲಾ ಹಕ್ಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಶೀರ್ಷಿಕೆ ಮತ್ತು ಆಸಕ್ತಿಯನ್ನು ಮತ್ತು ಅಂತಹ ಪ್ರತಿಕ್ರಿಯೆಯ ಆಧಾರದ ಮೇಲೆ ಯಾವುದೇ ಬೆಳವಣಿಗೆಗಳನ್ನು ರಚಿಸುವ ವಿಶೇಷ ಹಕ್ಕನ್ನು ನೀವು ಇಲ್ಲಿ ನಮಗೆ ವಹಿಸಿಕೊಡುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾವು ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ಮುಕ್ತವಾಗಿ ಬಳಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಕಲಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬಹಿರಂಗಪಡಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರಕಟಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರದರ್ಶಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿತರಿಸಬಹುದು ಮತ್ತು ಬಳಸಿಕೊಳ್ಳಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.3000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l11 level1 lfo16;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳಲ್ಲಿ ಹೇಳಿರುವುದನ್ನು ಹೊರತುಪಡಿಸಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳಲ್ಲಿರುವ ಯಾವುದನ್ನೂ ನಮ್ಮ ಅಥವಾ ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಬೌದ್ಧಿಕ ಆಸ್ತಿ ಹಕ್ಕುಗಳಲ್ಲಿ ಯಾವುದೇ ಹಕ್ಕು ಅಥವಾ ಪರವಾನಗಿಯನ್ನು ನೀಡುತ್ತದೆ ಎಂದು ಅರ್ಥೈಸಿಕೊಳ್ಳಬಾರದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        9.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅವಧಿ ಹಾಗೂ ಕೊನೆಗೊಳಿಸುವಿಕೆ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳನ್ನು ಇಲ್ಲಿ ನೀಡಲಾದ ನಿಯಮಗಳಿಗೆ ಅನುಸಾರವಾಗಿ ಕೊನೆಗೊಳಿಸದ ಹೊರತು ಅವು ಜಾರಿಯಲ್ಲಿರುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.0500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಅಡಿಯಲ್ಲಿ ನೀವು ಯಾವುದೇ ಬಾಧ್ಯತೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಜವಾಬ್ದಾರಿಗಳು ಅಥವಾ ಒಪ್ಪಂದಗಳನ್ನು ಉಲ್ಲಂಘಿಸಿದರೆ ಅಥವಾ &nbsp;ಭಂಗಗೊಳಿಸಿದರೆ ಅಥವಾ ನಮ್ಮ ಸೇವೆಗಳು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ ಬಳಕೆದಾರರಾಗುವುದನ್ನು ನಿಲ್ಲಿಸಿದಾಗ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ ಅದರ ಯಾವುದೇ ಭಾಗಕ್ಕೆ ನಿಮ್ಮ ಪ್ರವೇಶ ಅಥವಾ ಬಳಕೆಯನ್ನು ನಾವು ತಕ್ಷಣವೇ ಮತ್ತು ಯಾವುದೇ ಹಂತದಲ್ಲಿ ನಮ್ಮ ಸ್ವಂತ ವಿವೇಚನೆಯಿಂದ ಕೊನೆಗೊಳಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.3000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l10 level1 lfo17;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಮುಕ್ತಾಯದ ನಂತರ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 10.6000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರೊಫೈಲ್ ಅವಧಿ ಮುಗಿಯುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಮಯ ಮೀರುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"; </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮತ್ತು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l21 level1 lfo18;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳು ಮುಕ್ತಾಯಗೊಳ್ಳುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸ್ಪಷ್ಟವಾಗಿ ಅಥವಾ ಮುಕ್ತಾಯ ಅಥವಾ ಅವಧಿ ಮುಗಿಯುವುದನ್ನು ತಪ್ಪಿಸಲು ಉದ್ದೇಶಿಸಿರುವ ಷರತ್ತುಗಳನ್ನು ಹೊರತುಪಡಿಸಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 13.0000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        10.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಕ್ಕು ನಿರಾಕರಣೆಗಳು ಮತ್ತು ಖಾತರಿಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿ ಅಥವಾ ಅದರ ಮೂಲಕ ಲಭ್ಯವಾಗುವಂತೆ ಮಾಡಲಾದ ಯಾವುದೇ ಹಣಕಾಸು ಮಾಹಿತಿಯ ನಿಖರತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೂಕ್ತತೆ ಅಥವಾ ಸರಿಯಾದತೆಯನ್ನು ನಾವು ಖಾತರಿಪಡಿಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.0500pt ;
text-align:justify;text-justify:inter-ideograph;line-height:147%;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">SANDBOX </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ನು ನಾವು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇರುವಂತೆಯೇ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">" </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಆಧಾರದ ಮೇಲೆ ಒದಗಿಸುತ್ತೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ರೀತಿಯ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸ್ಪಷ್ಟ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೂಚಿತ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಶಾಸನಬದ್ಧ ಅಥವಾ ಇತರ ಖಾತರಿಗಳಿಲ್ಲದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಶೀರ್ಷಿಕೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, NON-</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಉಲ್ಲಂಘನೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವ್ಯಾಪಾರೀಕರಣ ಅಥವಾ ನಿರ್ದಿಷ್ಟ ಉದ್ದೇಶಕ್ಕಾಗಿ ಸೂಕ್ತತೆ ಸೂಚಿತ ಖಾತರಿಗಳನ್ನು ಒಳಗೊಂಡಂತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">SANDBOX </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮ ಅಪ್ಲಿಕೇಶನ್ ಗಳೊಂದಿಗೆ ಅಥವಾ ನೀವು ಒದಗಿಸಿದ ಯಾವುದೇ ಇತರ ಹಾರ್ಡ್ವೇರ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಾಫ್ಟ್ವೇರ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಿಸ್ಟಮ್ಗಳು ಅಥವಾ ಡೇಟಾದೊಂದಿಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ ಎಂದು ನಾವು ಖಾತರಿಪಡಿಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇಂಟರ್ನೆಟ್ ಸೇರಿದಂತೆ ಸಂವಹನ ಸೌಲಭ್ಯಗಳ ಮೇಲೆ ಡೇಟಾ ವರ್ಗಾವಣೆಯನ್ನು ನಾವು ನಿಯಂತ್ರಿಸುವುದಿಲ್ಲ ಮತ್ತು ಸೇವೆಗಳು ಅಂತಹ ಸಂವಹನ ಸೌಲಭ್ಯಗಳ ಬಳಕೆಯಲ್ಲಿ ಅಂತರ್ಗತವಾಗಿರುವ ಮಿತಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿಳಂಬಗಳು ಮತ್ತು ಇತರ ಸಮಸ್ಯೆಗಳಿಗೆ ಒಳಪಟ್ಟಿರಬಹುದು ಎಂಬುದನ್ನು ನೀವು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮೇಲೆ ತಿಳಿಸಿದ್ದನ್ನು ಸೀಮಿತಗೊಳಿಸದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾವು ಯಾವುದೇ ಖಾತರಿಯನ್ನು ನೀಡುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 10.3500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l22 level1 lfo20;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್ಫಾರ್ಮ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿರುವ ಕಾರ್ಯಗಳು ನಿಮ್ಮ ಅವಶ್ಯಕತೆಗಳು ಅಥವಾ ನಿರೀಕ್ಷೆಗಳನ್ನು ಪೂರೈಸುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ ಸೇವೆಗಳು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ್ ನಿಮ್ಮ ಬಳಕೆಯು ಅಡೆತಡೆಯಿಲ್ಲದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಕಾಲಿಕವಾಗಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸುರಕ್ಷಿತವಾಗಿ ಅಥವಾ ದೋಷ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮುಕ್ತವಾಗಿರುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l22 level1 lfo20;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್ಫಾರ್ಮ್ನಲ್ಲಿರುವ ಯಾವುದೇ ದೋಷಗಳು ಅಥವಾ &nbsp;ನ್ಯೂನತೆಗಳನ್ನು ಸರಿಪಡಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.3000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮಿಂದ ನೀವು ಪಡೆದ ಯಾವುದೇ ಸಲಹೆ ಅಥವಾ ಮಾಹಿತಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅದು ಮೌಖಿಕವಾಗಿರಲಿ ಅಥವಾ ಲಿಖಿತವಾಗಿರಲಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಯಮಗಳಲ್ಲಿ ಸ್ಪಷ್ಟವಾಗಿ ಹೇಳದ ಯಾವುದೇ ಖಾತರಿಯನ್ನು ಸೃಷ್ಟಿಸುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಮತ್ತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ ನಿಮ್ಮ ಬಳಕೆಯಿಂದ ಉಂಟಾಗಬಹುದಾದ ಯಾವುದೇ ಪರಿಣಾಮಗಳಿಗೆ ನೀವು ಇಲ್ಲಿ ಸಂಪೂರ್ಣ ಜವಾಬ್ದಾರಿಯನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ ಮತ್ತು ಈ ವಿಷಯದಲ್ಲಿ ನಾವು ಯಾವುದೇ ಹೊಣೆಗಾರಿಕೆಯನ್ನು ಹೊಂದಿರುವುದಿಲ್ಲ ಎಂದು ಸ್ಪಷ್ಟವಾಗಿ ಒಪ್ಪುತ್ತೀರಿ ಮತ್ತು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.8000pt ;
line-height:144%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಣಕಾಸು ಮಾಹಿತಿ ಪೂರೈಕೆದಾರರಿಂದ ಕೋರಲಾದ ಕೆಲವು ಹಣಕಾಸು ಮಾಹಿತಿಯು ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿರಬಹುದು ಅಥವಾ ನೈಜ ಸಮಯದ ಮಾಹಿತಿಯನ್ನು ಹೊಂದಿಲ್ಲದಿರಬಹುದು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಡಿಮ್ಯಾಟ್ ಫೋಲಿಯೊಗಳಂತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮತ್ತು ಆದ್ದರಿಂದ ಸೂಕ್ತವಾಗಿ ಪ್ರತಿಫಲಿಸದಿರಬಹುದು ಎಂದು ನೀವು ಇಲ್ಲಿ ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇದನ್ನು ನಮ್ಮ ಸೇವೆಗಳಲ್ಲಿನ ಕೊರತೆ ಎಂದು ಭಾವಿಸಬಾರದು ಮತ್ತು ಅದಕ್ಕೆ ಅನುಗುಣವಾಗಿ ನಾವು ಒದಗಿಸಿದ ಮಾಹಿತಿಯ ಮೇಲೆ ಅವಲಂಬಿತರಾಗಬೇಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 10.8500pt ;
mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಾನೂನಿನಿಂದ ಅನುಮತಿಸಲಾದ ಪೂರ್ಣ ಮಟ್ಟಿಗೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾವು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಅಂಗಸಂಸ್ಥೆಗಳು ಮತ್ತು ಸಂಬಂಧಿತ ಪಕ್ಷಗಳು ಈ ಕೆಳಗಿನವುಗಳಿಂದ ಅಥವಾ ಕಾರಣದಿಂದಾಗಿ ಉಂಟಾಗುವ ಯಾವುದೇ ನಷ್ಟ ಅಥವಾ ಹಾನಿಗೆ ನಿಮ್ಮ ಮೇಲಿನ ಎಲ್ಲಾ ಹೊಣೆಗಾರಿಕೆಯನ್ನು ನಿರಾಕರಿಸುತ್ತೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.5500pt ;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (i)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮ್ಮಿಂದ ಯಾವುದೇ ನಿರಾಕರಣೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸ್ಥಗಿತತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಸಮರ್ಪಕ ಕಾರ್ಯ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಂಚನೆ ಅಥವಾ ನಿರ್ಲಕ್ಷ್ಯ ಸೇರಿದಂತೆ ಸೇವೆಗಳು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ್ ನಿಮ್ಮ ಬಳಕೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬಳಸಲು ಅಸಮರ್ಥತೆ ಅಥವಾ ಲಭ್ಯತೆ ಅಥವಾ ಅಲಭ್ಯತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.5500pt ;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (ii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳಿಗೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳಿಂದ ಅಥವಾ ಸೇವೆಗಳ ಮೂಲಕ ಮಾಹಿತಿಯ ಕಾರ್ಯಾಚರಣೆ ಅಥವಾ ಪ್ರಸರಣದಲ್ಲಿ ಯಾವುದೇ ದೋಷ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಡಚಣೆ ಅಥವಾ ವಿಳಂಬ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂವಹನ ವೈಫಲ್ಯ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಳ್ಳತನ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾಶ ಅಥವಾ ನಮ್ಮ ದಾಖಲೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕಾರ್ಯಕ್ರಮಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸರ್ವರ್ ಅಥವಾ ಸೇವೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಇತರ ಮೂಲಸೌಕರ್ಯಗಳಿಗೆ ಅನಧಿಕೃತ ಪ್ರವೇಶ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">; </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಥವಾ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.7500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳು ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಸಮಯದವರೆಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸಲು ವಿಫಲವಾದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.5000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (iv)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಫೋರ್ಸ್ ಮಜೂರ್ ಘಟನೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.3000pt ;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (v)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಗದಿತ ಅಲಭ್ಯತೆ ಮತ್ತು ನಿಗದಿತವಲ್ಲದ ಅಲಭ್ಯತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.7500pt ;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vi)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರಬಹುದಾದ ಅನ್ವಯವಾಗುವ ಕಾನೂನಿನಲ್ಲಿನ ಬದಲಾವಣೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 13.7000pt ;
mso-list:l14 level1 lfo21;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (vii)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗ್ರಾಹಕರಿಂದ ಒಪ್ಪಿಗೆಯನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 11.8000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇಲ್ಲಿರುವ ಯಾವುದೇ ವಿರೋಧಾಭಾಸಗಳ ಹೊರತಾಗಿಯೂ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾವು ಅಥವಾ ನಮ್ಮ ಯಾವುದೇ ಅಂಗಸಂಸ್ಥೆಗಳು ಅಥವಾ ಸಂಬಂಧಿತ ಪಕ್ಷಗಳು ಈ ನಿಯಮಗಳು ಅಥವಾ ಸೇವೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೇರವಾಗಿ ಅಥವಾ ಪರೋಕ್ಷವಾಗಿ ಅಥವಾ ಯಾವುದೇ ರೀತಿಯಲ್ಲಿ ಉಂಟಾಗುವ ಯಾವುದೇ ಪರೋಕ್ಷ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರಾಸಂಗಿಕ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿಶೇಷ ಅಥವಾ ಪರಿಣಾಮಕಾರಿ ಹಾನಿಗಳಿಗೆ ಅಥವಾ ಯಾವುದೇ ಆದಾಯ ಅಥವಾ ಲಾಭದ ನಷ್ಟಕ್ಕೆ ನಿಮಗೆ ಅಥವಾ ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಗೆ ಯಾವುದೇ ಹೊಣೆಗಾರಿಕೆಯನ್ನು ಹೊಂದಿರುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೇರ ಹಾನಿಗಳಿಗೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಕ್ರಮದ ರೂಪವನ್ನು ಲೆಕ್ಕಿಸದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಹೊಣೆಗಾರಿಕೆ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಒಪ್ಪಂದದಲ್ಲಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಪರಾಧ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿರ್ಲಕ್ಷ್ಯ ಸೇರಿದಂತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) 10,000 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರೂಪಾಯಿಗಳನ್ನು ಮೀರಬಾರದು ಎಂದು ನೀವು ಒಪ್ಪುತ್ತೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇಲ್ಲಿ ನೀಡಲಾಗಿರುವ ಯಾವುದೇ ಸೀಮಿತ ಪರಿಹಾರದ ಅಗತ್ಯ ಉದ್ದೇಶದ ವೈಫಲ್ಯದ ಹೊರತಾಗಿಯೂ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮೇಲಿನ ಹೊಣೆಗಾರಿಕೆಯ ಮಿತಿಗಳು ಅನ್ವಯವಾಗುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 12.0500pt ;
line-height:144%;mso-list:l2 level1 lfo19;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (h)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ನು ಪ್ರವೇಶಿಸುವ ಉದ್ದೇಶಕ್ಕಾಗಿ ಈ ಪ್ಲಾಟ್ಫಾರ್ಮ್ ಅನ್ನು ಬಳಸುತ್ತಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಕೊಡುಗೆಗಳ ಮೌಲ್ಯಮಾಪನಕ್ಕಾಗಿ ಮಾತ್ರ ನಾವು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನ್ನು ಹೊಂದಿದ್ದೇವೆ ಎಂದು ನೀವು ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೀರಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಸಂದರ್ಭದಲ್ಲಿ ಇದನ್ನು ವಾಣಿಜ್ಯ ಸೇವೆ ಎಂದು ಪರಿಗಣಿಸಬಾರದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಕೊಡುಗೆಗಳಿಗೆ ನೀವು ಚಂದಾದಾರಿಕೆಯನ್ನು ಬಳಸಲು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">/</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪಡೆಯಲು ಬಯಸಿದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು </span>
                <u>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">support@cookiejar.co.in</span>
                </u>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:3.2000pt;tab-stops:left blank 13.2500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        11.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಷ್ಟ ಪರಿಹಾರ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:3.2000pt;">
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ಲಾಟ್ಫಾರ್ಮ್ಗೆ ನಿಮ್ಮ ಪ್ರವೇಶ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೇವೆಗಳ ಬಳಕೆ ಅಥವಾ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">Sandbox, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಯಾವುದೇ ಕೃತ್ಯ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಲೋಪ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಂಚನೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿರ್ಲಕ್ಷ್ಯ ಅಥವಾ ಉಲ್ಲಂಘನೆ ಅಥವಾ ಸೇವೆಗಳನ್ನು ಪ್ರವೇಶಿಸಲು ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಬಳಸಬಹುದಾದ ನಿಮ್ಮಿಂದ ಅಥವಾ ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಯಿಂದ ಈ ನಿಯಮಗಳ ಯಾವುದೇ ಉಲ್ಲಂಘನೆಯಿಂದಾಗಿ ಅಥವಾ ಉಂಟಾಗುವ ಯಾವುದೇ ಹಕ್ಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬೇಡಿಕೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮೊಕದ್ದಮೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ್ಯಾಯಾಂಗ ಪ್ರಕ್ರಿಯೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಷ್ಟಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹೊಣೆಗಾರಿಕೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಾನಿಗಳು ಮತ್ತು ವೆಚ್ಚಗಳು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಿತಿಯಿಲ್ಲದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಎಲ್ಲಾ ಹಾನಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹೊಣೆಗಾರಿಕೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಸಾಹತುಗಳು ಮತ್ತು ವಕೀಲರ ಶುಲ್ಕಗಳು ಸೇರಿದಂತೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಹಕ್ಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬೇಡಿಕೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮೊಕದ್ದಮೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ್ಯಾಯಾಂಗ ಪ್ರಕ್ರಿಯೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಷ್ಟಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹೊಣೆಗಾರಿಕೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಹಾನಿಗಳು ಮತ್ತು ವೆಚ್ಚಗಳಿಂದ ನೀವು ನಮ್ಮ ಆಯ್ಕೆಯ ಮೇರೆಗೆ ಪರಿಹಾರ ನೀಡಬೇಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರಕ್ಷಿಸಬೇಕು ಮತ್ತು ನಮ್ಮನ್ನು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಪೋಷಕ ಕಂಪನಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂಗಸಂಸ್ಥೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂಗಸಂಸ್ಥೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗುಂಪು ಕಂಪನಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಜಂಟಿ ಉದ್ಯಮಗಳು ಮತ್ತು ಅವುಗಳ ಅಧಿಕಾರಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಉದ್ಯೋಗಿಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿರ್ದೇಶಕರು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಏಜೆಂಟ್ಗಳು ಮತ್ತು ಪ್ರತಿನಿಧಿಗಳನ್ನು ಹಾನಿಯಿಂದ ಮುಕ್ತಗೊಳಿಸಬೇಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 13.2500pt ;
mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        12.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನ್ಯಾಯವ್ಯಾಪ್ತಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಆಡಳಿತ ಕಾನೂನುಗಳು ಮತ್ತು ವಿವಾದ ಪರಿಹಾರ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳನ್ನು ಭಾರತದ ಕಾನೂನುಗಳಿಗೆ ಅನುಸಾರವಾಗಿ ನಿಯಂತ್ರಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಅರ್ಥೈಸಲಾಗುತ್ತದೆ ಮತ್ತು ಜಾರಿಗೊಳಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ಷರತ್ತಿನಲ್ಲಿರುವ ಇತರ ನಿಬಂಧನೆಗಳಿಗೆ ಒಳಪಟ್ಟು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪುಣೆಯ ನ್ಯಾಯಾಲಯಗಳು ಈ ನಿಯಮಗಳಿಂದ ಅಥವಾ ಸೇವೆಗಳ ಬಳಕೆಯಿಂದ ಉಂಟಾಗುವ ಎಲ್ಲಾ ಸಮಸ್ಯೆಗಳ ಮೇಲೆ ವಿಶೇಷ ನ್ಯಾಯವ್ಯಾಪ್ತಿಯನ್ನು ಹೊಂದಿರುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 12.0500pt ;line-height:144%;
mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳಿಂದ ಉಂಟಾಗುವ ಯಾವುದೇ ವಿವಾದಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಘರ್ಷಣೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿವಾದಗಳು ಅಥವಾ ಭಿನ್ನಾಭಿಪ್ರಾಯಗಳನ್ನು ಪುಣೆಯಲ್ಲಿನ ಮಧ್ಯಸ್ಥಿಕೆ ಮತ್ತು ಸಂಧಾನ ಕಾಯ್ದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, 1996 </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ರ ಪ್ರಕಾರ ಪರಿಹರಿಸಲಾಗುವುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇದನ್ನು ಈ ಷರತ್ತಿನಲ್ಲಿ ಉಲ್ಲೇಖದ ಮೂಲಕ ಸೇರಿಸಲಾಗಿದೆ ಎಂದು ಪರಿಗಣಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಧ್ಯಸ್ಥಿಕೆಯ ಭಾಷೆ ಇಂಗ್ಲಿಷ್ ಆಗಿರಬೇಕು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಧ್ಯಸ್ಥಿಕೆಗೆ ಸಂಬಂಧಿಸಿದ ಪಕ್ಷಗಳು ಮಧ್ಯಸ್ಥಿಕೆಯನ್ನು ಗೌಪ್ಯವಾಗಿಡಬೇಕು ಮತ್ತು ಕಾನೂನಿನ ಪ್ರಕಾರ ಅಗತ್ಯವಿದ್ದಲ್ಲಿ ಅಥವಾ ಕಾನೂನು ಸಲಹೆಗಾರರಿಗೆ ಹೊರತುಪಡಿಸಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ವ್ಯಕ್ತಿಗೆ ಬಹಿರಂಗಪಡಿಸಬಾರದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಧ್ಯಸ್ಥಗಾರರ ನಿರ್ಧಾರವು ಅಂತಿಮವಾಗಿರುತ್ತದೆ ಮತ್ತು ಇಲ್ಲಿ ಎಲ್ಲಾ ಪಕ್ಷಗಳ ಮೇಲೆ ಬದ್ಧವಾಗಿರುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l4 level1 lfo22;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ವಿವಾದಕ್ಕೆ ಸಂಬಂಧಿಸಿದಂತೆ ಮಧ್ಯಸ್ಥಿಕೆಯ ಪ್ರತಿಯೊಂದು ಪಕ್ಷವು ತನ್ನದೇ ಆದ ವೆಚ್ಚವನ್ನು ಭರಿಸುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಆನ್ಲೈನ್ ವಿವಾದ ಪರಿಹಾರ ವ್ಯವಸ್ಥೆ</span>
                <u>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(51,94,232);font-weight:normal;text-decoration:underline;
text-underline:single;font-style:normal;font-variant:normal;
font-size:12.75pt;">ODR</span>
                </u>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೊಂದಿಗೆ ಸಹ ವಿವಾದವನ್ನು ಎತ್ತಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;margin-bottom:6.0000pt;tab-stops:left blank 13.0000pt ;
mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        13.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದೂರು ಪರಿಹಾರ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಯಾವುದೇ ದೂರುಗಳನ್ನು ಸಲ್ಲಿಸಲು ಬಯಸಿದರೆ ದಯವಿಟ್ಟು ವೆಬ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೈಟ್</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <font face="Anek Kannada">&#8204;</font>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಲ್ಲಿರುವ ದೂರು ಆಯ್ಕೆಯನ್ನು ನೋಡಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಸಂದರ್ಭದಲ್ಲಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದೂರಿನ ದಿನಾಂಕದಿಂದ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">30 (</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮೂವತ್ತು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">) </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದಿನಗಳ ಒಳಗೆ ನಿಮ್ಮ ದೂರು ಬಗೆಹರಿಯುವುದನ್ನು ನಾವು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳುತ್ತೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l8 level1 lfo23;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂತಹ ಅವಧಿಯೊಳಗೆ ದೂರನ್ನು ಪರಿಹರಿಸದಿದ್ದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಈ ಕೆಳಗಿನ ವಿಳಾಸಗಳಲ್ಲಿ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">RBI </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗೆ ಮೇಲ್ಮನವಿ ಸಲ್ಲಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">-</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <div align=center>
                <table class=MsoNormalTable border=0 cellspacing=0 style="border-collapse:collapse;mso-table-layout-alt:fixed;border:none;
mso-padding-alt:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;">
                    <tr style="height:16.3000pt;">
                        <td width=466 valign=center colspan=2 style="width:279.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 align=center style="margin-right:20.9000pt;margin-bottom:0.0000pt;text-align:center;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಮುಂಬೈ </span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">(</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಪ್ರಾದೇಶಿಕ ಕಚೇರಿ</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">)</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.5500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 style="margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ನ್ಯಾಯವ್ಯಾಪ್ತಿ</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಮಹಾರಾಷ್ಟ್ರ ರಾಜ್ಯ ಮತ್ತು ಗೋವಾ ರಾಜ್ಯ</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:15.8500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 style="margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ವಿಳಾಸ</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">3</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ನೇ ಮಹಡಿ</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, RBI </span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಕಟ್ಟಡ</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಮುಂಬೈ ಸೆಂಟ್ರಲ್ ರೈಲ್ವೆ ನಿಲ್ದಾಣ ಎದುರು</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಮರಾಠಾ ಮಂದಿರ ಹತ್ತಿರ</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಬೈಕುಲ್ಲಾ</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">, </span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಮುಂಬೈ </span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">- 400 008</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.1000pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 style="margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ದೂರವಾಣಿ</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">022-2308 4121/2302 8436</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.3000pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 style="margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಫ್ಯಾಕ್ಸ್</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;">
                            <p class=20 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">022 2302 2011</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr style="height:16.5500pt;">
                        <td width=56 valign=center style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;">
                            <p class=20 style="margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಇ</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">-</span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">ಮೇಲ್</span>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                        <td width=410 valign=center style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;">
                            <p class=20 style="margin-right:20.9000pt;margin-bottom:0.0000pt;margin-left:1.4500pt;">
                                <span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;">
                                    <a href="mailto:dnbsmro@rbi.or">dnbsmro@rbi.or</a>
                                </span>
                                <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;">g</span>
                                <u>
                                    <span class="15" style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;">.in</span>
                                </u>
                                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;">
                                    <o:p></o:p>
                                </span>
                            </p>
                        </td>
                    </tr>
                </table>
            </div>
            <p class=MsoNormal style="margin-right:20.9000pt;margin-bottom:3.9500pt;line-height:0.0500pt;
mso-line-height-rule:exactly;">
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:'Courier New';
color:rgb(0,0,0);font-size:12.0000pt;">
                    <o:p>&nbsp;</o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;margin-bottom:9.0000pt;tab-stops:left blank 13.0000pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l19 level1 lfo1;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(22,28,45);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        14.<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]><span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(22,28,45);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವಿವಿಧ ನಿಬಂಧನೆಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;line-height:144%;
mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (a)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾರ್ಪಾಡು</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳನ್ನು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಮಾರ್ಪಡಿಸುವ ಮತ್ತು ಸೇವೆಗಳ ಬಳಕೆಯ ಮೇಲೆ ಹೊಸ ಅಥವಾ ಹೆಚ್ಚುವರಿ ನಿಯಮಗಳು ಅಥವಾ ಷರತ್ತುಗಳನ್ನು ಸೇರಿಸುವ ಹಕ್ಕನ್ನು ನಾವು ಕಾಯ್ದಿರಿಸಿದ್ದೇವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂತಹ ಮಾರ್ಪಾಡುಗಳು ಮತ್ತು ಹೆಚ್ಚುವರಿ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ನಿಮಗೆ ತಿಳಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಸ್ಪಷ್ಟವಾಗಿ ತಿರಸ್ಕರಿಸದ ಹೊರತು </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳು ಕೊನೆಗೊಳ್ಳುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">), </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ತಕ್ಷಣವೇ ಜಾರಿಗೆ ಬರುತ್ತವೆ ಮತ್ತು ಈ ನಿಯಮಗಳಲ್ಲಿ ಸೇರಿಸಲ್ಪಡುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನೀವು ಅಂತಹ ಬದಲಾವಣೆಗಳನ್ನು ಸ್ವೀಕರಿಸಲು ನಿರಾಕರಿಸಿದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳು ಕೊನೆಗೊಳ್ಳುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.2500pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (b)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಪ್ರತ್ಯೇಕತೆ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಯಾವುದೇ ನಿಬಂಧನೆಯು ಯಾವುದೇ ನ್ಯಾಯಾಲಯ ಅಥವಾ ಇತರ ಸಕ್ಷಮ ಪ್ರಾಧಿಕಾರದಿಂದ ಕಾನೂನುಬಾಹಿರ ಅಥವಾ ಜಾರಿಗೊಳಿಸಲಾಗದು ಎಂದು ನಿರ್ಧರಿಸಲ್ಪಟ್ಟರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಇತರ ನಿಬಂಧನೆಗಳು ಜಾರಿಯಲ್ಲಿ ಮುಂದುವರಿಯುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಕಾನೂನುಬಾಹಿರ ಅಥವಾ ಜಾರಿಗೊಳಿಸಲಾಗದ ನಿಬಂಧನೆಯು ಕಾನೂನುಬದ್ಧವಾಗಿದ್ದರೆ ಅಥವಾ ಜಾರಿಗೊಳಿಸಬಹುದಾದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅದರ ಒಂದು ಭಾಗವನ್ನು ಅಳಿಸಿದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಆ ಭಾಗವನ್ನು ಅಳಿಸಲಾಗಿದೆ ಎಂದು ಪರಿಗಣಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಉಳಿದ ನಿಬಂಧನೆಯು ಜಾರಿಯಲ್ಲಿ ಮುಂದುವರಿಯುತ್ತದೆ </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">(</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅದು ಷರತ್ತಿನ ಸ್ಪಷ್ಟ ಉದ್ದೇಶಕ್ಕೆ ವಿರುದ್ಧವಾಗಿರದ ಹೊರತು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸಂಬಂಧಿತ ನಿಬಂಧನೆಯ ಸಂಪೂರ್ಣತೆಯನ್ನು ಅಳಿಸಲಾಗಿದೆ ಎಂದು ಪರಿಗಣಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">).</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (c)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಯೋಜನೆ</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಪೂರ್ವ ಲಿಖಿತ ಒಪ್ಪಿಗೆಯಿಲ್ಲದೆ ನೀವು ಈ ನಿಯಮಗಳ ಅಡಿಯಲ್ಲಿ ಅವರ ಹಕ್ಕುಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಬಾಧ್ಯತೆಗಳು ಅಥವಾ ಒಪ್ಪಂದಗಳಿಗೆ ಪರವಾನಗಿ ನೀಡಬಾರದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮಾರಾಟ ಮಾಡಬಾರದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ವರ್ಗಾಯಿಸಬಾರದು ಅಥವಾ ನಿಯೋಜಿಸಬಾರದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾವು ನಮ್ಮ ಸ್ವಂತ ವಿವೇಚನೆಯಿಂದ ಮತ್ತು ನಾವು ಸೂಕ್ತವೆಂದು ಭಾವಿಸುವ ಯಾವುದೇ ಷರತ್ತುಗಳಿಗೆ ಒಳಪಟ್ಟು ಈ ಸಮ್ಮತಿಯನ್ನು ನೀಡಬಹುದು ಅಥವಾ ತಡೆಹಿಡಿಯಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಮಗೆ ಯಾವುದೇ ಪೂರ್ವ ಸೂಚನೆ ನೀಡದೆಯೇ ನಾವು ನಮ್ಮ ಯಾವುದೇ ಅಂಗಸಂಸ್ಥೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅಂಗಸಂಸ್ಥೆಗಳು ಅಥವಾ ಪೋಷಕ ಕಂಪನಿಗಳಿಗೆ ಅಥವಾ ಸೇವೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ವ್ಯವಹಾರದ ಹಿತಾಸಕ್ತಿಯಲ್ಲಿರುವ ಯಾವುದೇ ಉತ್ತರಾಧಿಕಾರಿಗೆ ನಮ್ಮ ಹಕ್ಕುಗಳನ್ನು ನಿಯೋಜಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (d)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಸೂಚನೆಗಳು</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಅಡಿಯಲ್ಲಿ ನಮಗಾಗಿ ಎಲ್ಲಾ ಸೂಚನೆಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">, </span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">ವಿನಂತಿಗಳು</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">, </span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">ಬೇಡಿಕೆಗಳು ಮತ್ತು ನಿರ್ಣಯಗಳನ್ನು </span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">(</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">ನಿಯಮಿತ ಕಾರ್ಯಾಚರಣೆ ಸಂವಹನಗಳನ್ನು ಹೊರತುಪಡಿಸಿ</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">)</span>
                <span>
                    <a href="mailto:info@cookiejar.co.in">
                        <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">info@cookiejar.co.in</span>
                    </a>
                </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗೆ ಕಳುಹಿಸಲಾಗುತ್ತದೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.3000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (e)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಹಕ್ಕುಗಳು</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇಲ್ಲಿರುವ ಯಾವುದೇ ನಿಯಮಗಳನ್ನು ಜಾರಿಗೊಳಿಸಲು ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಗೆ ಯಾವುದೇ ಹಕ್ಕಿರುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText align=justify style="margin-right:20.9000pt;tab-stops:left blank 11.1000pt ;text-align:justify;
text-justify:inter-ideograph;line-height:145%;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (f)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫೋರ್ಸ್ ಮೇಜುರ್</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">: </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಜವಾಬ್ದಾರಿಗಳನ್ನು ನಿರ್ವಹಿಸುವುದರಿಂದ ಅಥವಾ ನಮ್ಮ ವ್ಯವಹಾರವನ್ನು ನಡೆಸುವುದರಿಂದ ವಿಳಂಬವಾದರೆ ಅಥವಾ ತಡೆಯಲ್ಪಟ್ಟರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಮ್ಮ ಸಮಂಜಸ ನಿಯಂತ್ರಣಕ್ಕೆ ಮೀರಿದ ಕೃತ್ಯಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಘಟನೆಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಲೋಪಗಳು ಅಥವಾ ಅಪಘಾತಗಳು ಸಂಭವಿಸಿದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಮುಷ್ಕರಗಳು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಉಪಯುಕ್ತತಾ ಸೇವೆ ಅಥವಾ ದೂರಸಂಪರ್ಕ ಜಾಲದ ವೈಫಲ್ಯ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದೇವರ ಕೃತ್ಯ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯುದ್ಧ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಗಲಭೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಾಗರಿಕ ಗಲಭೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ದುರುದ್ದೇಶಪೂರಿತ ಹಾನಿ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಯಾವುದೇ ಕಾನೂನು ಅಥವಾ ಸರ್ಕಾರಿ ಆದೇಶ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಯಮ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ನಿಯಂತ್ರಣ ಅಥವಾ ನಿರ್ದೇಶನದ ಅನುಸರಣೆ ಸೇರಿದಂತೆ ನಾವು ನಿಮಗೆ ಯಾವುದೇ ಹೊಣೆಗಾರಿಕೆಯನ್ನು ಹೊಂದಿರುವುದಿಲ್ಲ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. (</span>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಫೋರ್ಸ್ ಮಜೂರ್ ಈವೆಂಟ್</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">"</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">)</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
            <p class=MsoBodyText style="margin-right:20.9000pt;tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;">
                <![if !supportLists]>
                <span style="font-family:'Anek Kannada';mso-fareast-font-family:Arial;color:rgb(56,76,116);
letter-spacing:0.0000pt;font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">
                    <span style='mso-list:Ignore;'>
                        (g)<span>&nbsp;</span>
                    </span>
                </span>
                <![endif]>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಅನುವಾದಗಳು</span>
                </b>
                <b>
                    <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:bold;font-style:normal;
font-variant:normal;font-size:12.75pt;">:</span>
                </b>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">&nbsp;</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳನ್ನು ಹೆಚ್ಚು ವಿವರವಾಗಿ ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ನಿಮಗೆ ಸಹಾಯ ಮಾಡಲು ಮಾತ್ರ ನಾವು ಈ ನಿಯಮಗಳ ಅನುವಾದಿತ ಆವೃತ್ತಿಗಳನ್ನು ನಿಮಗೆ ಒದಗಿಸಬಹುದು</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">. </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಈ ನಿಯಮಗಳ ಇಂಗ್ಲಿಷ್ ಆವೃತ್ತಿ ಮತ್ತು ಯಾವುದೇ ಅನುವಾದಿತ ಆವೃತ್ತಿಯ ನಡುವೆ ಯಾವುದೇ ಅಸಂಗತತೆ ಉಂಟಾದರೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">, </span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">ಇಂಗ್ಲಿಷ್ ಆವೃತ್ತಿಯ ನಿಯಮಗಳು ಮೇಲುಗೈ ಸಾಧಿಸುತ್ತವೆ</span>
                <span class="18" style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-weight:normal;font-style:normal;
font-variant:normal;font-size:12.75pt;">.</span>
                <span style="mso-spacerun:'yes';font-family:'Anek Kannada';mso-fareast-font-family:Arial;
color:rgb(56,76,116);font-size:12.75pt;">
                    <o:p></o:p>
                </span>
            </p>
        </div>
        <!--EndFragment-->
    </body>
</html>
`,
};
